<template>
  <v-container v-if="this.user != ''">
    <!-- <v-card class="mx-auto red">
        <v-card-title>Add Users To Notice</v-card-title>
        <v-text-field
            v-model="noticeId"
            @change="getNotice()"
            dense
            filled
            label="notice"
          ></v-text-field>
          <v-row><v-col class = "mx-2" cols="11">
            {{ noticeDescription.noticeTitle }}
            </v-col><v-col class = "mx-2" cols="11">
            {{ noticeDescription.noticeDescription }}
          </v-col><v-col class = "mx-2" cols="11">
            {{ noticeDescription.noticeLink }}
          </v-col></v-row>

        <v-btn
              class="mx-4 my-5"
              dark
              @click="addDeviceOwnersToNotice()"
              >Add Device Owners
            </v-btn>
      </v-card> -->

    <v-expansion-panels v-model="deviceHistoryPanel" class="mb-2">
      <v-expansion-panel @change="onDeviceHistoryExpand">
        <v-expansion-panel-header color="rgb(0, 255, 200, 0.6)">
          Added Past Week
          <template v-slot:actions>
            <v-btn
              icon
              small
              v-tooltip.bottom-start="'Refresh'"
              @click.stop="refreshDeviceHistory()"
              class="mr-2"
            >
              <v-icon small>mdi-refresh</v-icon>
            </v-btn>
            <v-icon>$expand</v-icon>
          </template>
        </v-expansion-panel-header>
        <v-expansion-panel-content color="rgb(0, 255, 200, 0.6)">
          <v-data-table
            dense
            :headers="historyHeaders"
            :items="filteredDeviceHistory"
            class="elevation-1"
            sort-by="createdAt"
            sort-desc
            @click:row="handleHistoryClick"
          >
            <template v-slot:[`item.deviceType`]="{ item }">
              <v-chip
                x-small
                :color="item.deviceType === 'Bird' ? 'green' : item.deviceType === 'Bat' ? 'purple' : 'grey'"
                text-color="white"
              >
                {{ item.deviceType }}
              </v-chip>
            </template>
          </v-data-table>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>

    <v-card dark class="mx-auto" color="rgb(80, 80, 80, 0.6)">
      <v-card-title>Haikubox Admin
        <v-spacer></v-spacer>
        <v-btn small dark @click="resetAdmin()">Reset</v-btn>
      </v-card-title>

      <!-- Quick Lookup: Paste Serial or Email -->
      <v-card-subtitle class="pb-0 white--text">Quick Lookup</v-card-subtitle>
      <v-row class="px-4" dense align="center">
        <v-col cols="12" sm="5">
          <v-text-field
            v-model="serialInput"
            label="Paste Serial or MAC"
            dense
            filled
            clearable
            @keydown.enter="selectHaikubox(serialInput)"
            append-icon="mdi-arrow-right"
            @click:append="selectHaikubox(serialInput)"
          ></v-text-field>
        </v-col>
        <v-col cols="12" sm="1" class="text-center grey--text hidden-xs-only">OR</v-col>
        <v-col cols="12" sm="5">
          <v-text-field
            v-model="emailInput"
            label="Paste Email"
            dense
            filled
            clearable
            @keydown.enter="lookupEmail()"
            append-icon="mdi-arrow-right"
            @click:append="lookupEmail()"
          ></v-text-field>
        </v-col>
      </v-row>

      <v-divider class="mx-4 my-2"></v-divider>

      <!-- Search: Browse by Name or Partial Email -->
      <v-card-subtitle class="pb-0 white--text">Search</v-card-subtitle>
      <v-row class="px-4" dense align="center">
        <v-col cols="12" sm="5">
          <v-combobox
            :items="haikuboxList"
            :label="haikuboxListLoading ? 'Loading devices... (' + haikuboxList.length + ')' : 'Search by device name'"
            v-model="haikubox"
            @change="selectHaikubox(haikubox)"
            auto-select-first
            :loading="haikuboxListLoading ? 'light-blue' : false"
            @focus="onDeviceSearchFocus()"
            :menu-props="{ bottom: true, offsetY: true, contentClass: 'admin-device-menu' }"
            dense
            filled
          ></v-combobox>
        </v-col>
        <v-col cols="12" sm="1" class="text-center grey--text hidden-xs-only">OR</v-col>
        <v-col cols="12" sm="5">
          <v-autocomplete
            v-model="email"
            :items="usersList"
            :search-input.sync="getUsersByEmail"
            @change="getDevicesByOwner()"
            @keydown.enter="onEmailEnter"
            :loading="emailSearching ? 'light-blue' : false"
            dense
            filled
            label="Search by partial email"
          ></v-autocomplete>
        </v-col>
      </v-row>
      <v-row class="px-4" dense>
        <v-col cols="8">
          <v-card-text>Email: {{ email }}</v-card-text>
          <v-card-text v-if="userNotFound" class="red--text text--lighten-1"
            >No account found for {{ email }}</v-card-text
          >
          <v-card-text v-if="userID">Owner ID: {{ userID }}</v-card-text>
          <v-card-text v-if="confirmedEmail"
            >Account confirmed: Yes</v-card-text
          >
          <v-card-text v-if="confirmedEmail === false"
            >Account confirmed: No</v-card-text
          >
          <v-card-text
            >Account last updated: {{ accountUpdatedAt }} ET</v-card-text
          >
          <v-card-text>Number of Haikuboxes: {{ numHaikuboxes }}</v-card-text>
          <v-card-text
            >One Signal Consent for Notifications Granted:
            {{ oneSignalConsentGranted }}</v-card-text
          >
        </v-col>
      </v-row>
      <v-data-table
        dense
        :headers="mergedDeviceHeaders"
        :items="mergedDeviceData"
        class="elevation-1"
        show-expand
        single-expand
        item-key="serial"
        :expanded.sync="expandedDevices"
        @click:row="handleHistoryClick"
        @item-expanded="onDeviceRowExpanded"
      >
        <template v-slot:[`item.wifiSignal`]="{ item }">
          <div class="text-center">
            <v-chip
              v-if="item.wifiSignal === 'disconnected'"
              x-small
              color="red"
              text-color="white"
            >
              disconnected
            </v-chip>
            <v-chip
              v-else-if="item.wifiSignal !== ''"
              x-small
              :color="item.wifiSignal > -70 ? 'green' : item.wifiSignal > -80 ? 'orange' : 'red'"
              text-color="white"
            >
              {{ item.wifiSignal }} dBm
            </v-chip>
            <div v-if="item.lastReported" style="font-size: 10px;" :style="{ color: item.lastReportedMinutes <= 15 ? '#4CAF50' : item.lastReportedMinutes <= 60 ? '#FBC02D' : '#F44336' }">
              {{ item.lastReported }}
            </div>
          </div>
        </template>
        <template v-slot:expanded-item="{ headers, item }">
          <td
            :colspan="headers.length"
            class="pa-3"
            style="background: #263238; border-left: 4px solid #2196f3;"
          >
            <v-row dense>
              <v-col cols="6" sm="3"><strong>Lat:</strong> {{ item.lat }}</v-col>
              <v-col cols="6" sm="3"><strong>Lon:</strong> {{ item.lon }}</v-col>
              <v-col cols="6" sm="3"><strong>Share:</strong> {{ item.shareBird }}</v-col>
              <v-col cols="6" sm="3" v-if="item.diagnosis">
                <strong>Diagnosis:</strong>
                <v-chip x-small color="orange" text-color="white">{{ item.diagnosis }}</v-chip>
              </v-col>
            </v-row>
            <v-row dense>
              <v-col cols="6" sm="3"><strong>First Connected:</strong> {{ item.createdAt }}</v-col>
              <v-col cols="6" sm="3"><strong>Updated:</strong> {{ item.updatedAt }}</v-col>
            </v-row>
            <v-row dense>
              <v-col cols="6" sm="4">
                <strong>Sub Owner:</strong>
                <v-chip v-if="item.subOwnerMismatch" x-small color="red" text-color="white">MISMATCH</v-chip>
                {{ item.subOwner }}
              </v-col>
              <v-col cols="6" sm="3"><strong>Auto Renew:</strong> {{ item.autoRenew }}</v-col>
              <v-col cols="6" sm="3"><strong>Stripe Cust:</strong> {{ item.stripeCustomer }}</v-col>
            </v-row>
            <!-- Apple in-app subscription -->
            <v-row dense v-if="item.appleOriginalTransactionId">
              <v-col cols="12" sm="5">
                <strong>Apple Txn:</strong> {{ item.appleOriginalTransactionId }}
              </v-col>
              <v-col cols="6" sm="4">
                <strong>Apple End:</strong> {{ item.applePeriodEndUnix || '?' }}
              </v-col>
              <v-col cols="6" sm="3">
                <strong>Apple Auto Renew:</strong>
                {{ item.appleAutoRenew === '' ? '?' : item.appleAutoRenew }}
              </v-col>
            </v-row>
            <v-divider dark class="my-2"></v-divider>
            <!-- Device State: hardware model, type, bat capability -->
            <div class="mb-1">
              <strong>Device State</strong>
              <v-progress-circular
                v-if="expandedDeviceStateLoading"
                indeterminate
                size="14"
                width="2"
                class="ml-2"
              ></v-progress-circular>
            </div>
            <v-row dense v-if="expandedDeviceState">
              <v-col cols="6" sm="3"><strong>Type:</strong> {{ expandedDeviceState.type || '?' }}</v-col>
              <v-col cols="6" sm="3"><strong>hModel:</strong> {{ expandedDeviceState.hModel || '?' }}</v-col>
              <v-col cols="6" sm="3">
                <strong>Bat Capable:</strong>
                <v-chip
                  x-small
                  :color="expandedDeviceState.batCapable == null ? 'grey' : expandedDeviceState.batCapable ? 'purple' : 'green'"
                  text-color="white"
                >
                  {{ expandedDeviceState.batCapable == null ? '?' : expandedDeviceState.batCapable ? 'bat' : 'bird' }}
                </v-chip>
              </v-col>
              <v-col cols="6" sm="3"><strong>Connected:</strong> {{ expandedDeviceState.connected == null ? '?' : expandedDeviceState.connected }}</v-col>
              <v-col cols="6" sm="3"><strong>Version:</strong> {{ expandedDeviceState.version == null ? '?' : expandedDeviceState.version }}</v-col>
              <v-col cols="6" sm="3"><strong>Timezone:</strong> {{ expandedDeviceState.timezone || '?' }}</v-col>
              <v-col cols="6" sm="3"><strong>Lat:</strong> {{ expandedDeviceState.lat == null ? '?' : expandedDeviceState.lat }}</v-col>
              <v-col cols="6" sm="3"><strong>Lon:</strong> {{ expandedDeviceState.lon == null ? '?' : expandedDeviceState.lon }}</v-col>
              <v-col cols="6" sm="3"><strong>Created:</strong> {{ fmtStateDate(expandedDeviceState.createdAt) }}</v-col>
              <v-col cols="6" sm="3"><strong>Updated:</strong> {{ fmtStateDate(expandedDeviceState.updatedAt) }}</v-col>
            </v-row>
            <div
              v-if="!expandedDeviceStateLoading && !expandedDeviceState"
              class="grey--text"
            >
              No deviceState record for {{ item.serial }}
            </div>
            <v-divider dark class="my-2"></v-divider>
            <!-- Device History: name/owner/settings changes over time -->
            <div class="mb-1">
              <strong>Device History</strong>
              <v-progress-circular
                v-if="serialHistoryLoading"
                indeterminate
                size="14"
                width="2"
                class="ml-2"
              ></v-progress-circular>
            </div>
            <v-data-table
              v-if="serialHistoryRows.length > 0"
              dense
              dark
              :headers="serialHistoryHeaders"
              :items="serialHistoryRows"
              :items-per-page="10"
              class="elevation-1 mb-2"
            >
              <template v-slot:[`item.deviceAction`]="{ item: h }">
                <v-chip
                  x-small
                  :color="h.deviceAction === 'INSERT' ? 'green' : h.deviceAction === 'REMOVE' ? 'red' : 'blue'"
                  text-color="white"
                >
                  {{ h.deviceAction }}
                </v-chip>
              </template>
              <template v-slot:[`item.changes`]="{ item: h }">
                <span class="orange--text text--lighten-1">{{ h.changes }}</span>
              </template>
            </v-data-table>
            <div
              v-if="!serialHistoryLoading && serialHistoryRows.length === 0"
              class="grey--text"
            >
              No history records for {{ item.serial }}
            </div>
          </td>
        </template>
      </v-data-table>
    </v-card>
    <v-card class="mx-auto pa-10" outlined>
      <v-app-bar dark color="blue">
        {{ haikubox }}
        <v-spacer></v-spacer>
      </v-app-bar>
      <v-card-subtitle>
        v{{ firmwareVersion }}
        <span v-if="deviceStateQueried" class="ml-2 grey--text"
          >hModel: {{ deviceState && deviceState.hModel ? deviceState.hModel : "?" }}</span
        >
        <v-chip
          v-if="deviceTypeLabel"
          small
          :color="deviceTypeColor"
          text-color="white"
          class="ml-2"
        >
          {{ deviceTypeLabel }}
        </v-chip>
      </v-card-subtitle>
      <v-img height="100%" width="100%" v-if="lat != 0">
        <l-map
          :center="[lat, lon]"
          style="height: 400px; width: 100%"
          :zoomControl="false"
          :zoom="7"
        >
          <l-tile-layer :url="urlStates" :attribution="attributionSummary" />
          <l-marker :lat-lng="[lat, lon]" /> </l-map
      ></v-img>

      Boot History
      <v-list dense v-for="item in bootTable" :key="item.id">
        <v-list-item> v{{ item.version }}: {{ item.createdAt }}</v-list-item>
      </v-list>

      <!-- eBird Grid Species -->
      <v-expansion-panels v-if="lat != 0" class="my-4">
        <v-expansion-panel>
          <v-expansion-panel-header>
            eBird Grid Species (Week {{ gridWeek }}) | {{ Math.round(lat) }}, {{ Math.round(lon) }} | {{ gridSpecies.length }} species
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-row no-gutters align="center" class="mb-2">
              <v-btn icon small @click.stop="changeGridWeek(-1)"><v-icon small>mdi-chevron-left</v-icon></v-btn>
              <span>Week {{ gridWeek }}</span>
              <v-btn icon small @click.stop="changeGridWeek(1)"><v-icon small>mdi-chevron-right</v-icon></v-btn>
            </v-row>
            <v-progress-linear v-if="gridLoading" indeterminate color="blue"></v-progress-linear>
            <v-simple-table v-if="gridSpecies.length > 0" dense>
              <thead>
                <tr><th>Code</th><th>Common Name</th></tr>
              </thead>
              <tbody>
                <tr v-for="(sp, i) in gridSpecies" :key="i">
                  <td class="py-0">{{ sp.spCode }}</td>
                  <td class="py-0">{{ sp.cn }}</td>
                </tr>
              </tbody>
            </v-simple-table>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>

      <div class="mx-auto pa-12">
        <line-chart
          :colors="['#fcba03']"
          :height="150"
          ytitle="CPU Temp"
          :library="{
            scales: {
              xAxes: [
                {
                  type: 'time', time: { unit: 'hour', displayFormats: { hour: 'MMM DD HH:mm' } },
                  ticks: {
                    fontColor: '#000000',
                  },
                },
              ],
              yAxes: [
                {
                  ticks: {
                    fontColor: '#000000',
                  },
                },
              ],
            },
          }"
          :data="cpuTempSeries"
        ></line-chart>
        <!-- <column-chart
          :colors="['#fcba03']"
          :height="150"
          :min="0"
          :max="2"
          ytitle="CPU GHz"
          :library="{
            scales: {
              xAxes: [
                {
                  ticks: {
                    fontColor: '#000000',
                  },
                },
              ],
              yAxes: [
                {
                  ticks: {
                    fontColor: '#000000',
                  },
                },
              ],
            },
          }"
          :data="cpuFreqSeries"
        ></column-chart> -->
        <!-- <column-chart
          :colors="['#fcba03']"
          :height="150"
          :min="0"
          ytitle="ramdisk"
          :library="{
            scales: {
              xAxes: [
                {
                  ticks: {
                    fontColor: '#000000',
                  },
                },
              ],
              yAxes: [
                {
                  ticks: {
                    fontColor: '#000000',
                  },
                },
              ],
            },
          }"
          :data="ramdiskSeries"
        ></column-chart> -->
        <line-chart
          :colors="['#fcba03']"
          :height="150"
          ytitle="WiFi dBm"
          :library="{
            scales: {
              xAxes: [
                {
                  type: 'time', time: { unit: 'hour', displayFormats: { hour: 'MMM DD HH:mm' } },
                  ticks: {
                    fontColor: '#000000',
                  },
                },
              ],
              yAxes: [
                {
                  ticks: {
                    fontColor: '#000000',
                  },
                },
              ],
            },
          }"
          :data="signalSeries"
        ></line-chart>
        <line-chart
          :colors="['#fcba03']"
          :height="150"
          :ytitle="directChartLabel"
          :library="{
            scales: {
              xAxes: [
                {
                  type: 'time', time: { unit: 'hour', displayFormats: { hour: 'MMM DD HH:mm' } },
                  ticks: {
                    fontColor: '#000000',
                  },
                },
              ],
              yAxes: [
                {
                  ticks: {
                    fontColor: '#000000',
                  },
                },
              ],
            },
          }"
          :data="nDirectSeries"
        ></line-chart>
        <line-chart
          :colors="['#fcba03']"
          :height="150"
          :ytitle="cloudChartLabel"
          :library="{
            scales: {
              xAxes: [
                {
                  type: 'time', time: { unit: 'hour', displayFormats: { hour: 'MMM DD HH:mm' } },
                  ticks: {
                    fontColor: '#000000',
                  },
                },
              ],
              yAxes: [
                {
                  ticks: {
                    fontColor: '#000000',
                  },
                },
              ],
            },
          }"
          :data="nCloudSeries"
        ></line-chart>

        <line-chart
          v-if="freeGbSeries && freeGbSeries.length > 0"
          :colors="['#fcba03']"
          :height="150"
          ytitle="free GB"
          :library="{
            scales: {
              xAxes: [
                {
                  type: 'time', time: { unit: 'hour', displayFormats: { hour: 'MMM DD HH:mm' } },
                  ticks: {
                    fontColor: '#000000',
                  },
                },
              ],
              yAxes: [
                {
                  ticks: {
                    fontColor: '#000000',
                  },
                },
              ],
            },
          }"
          :data="freeGbSeries"
        ></line-chart>
        <line-chart
          v-if="vSeries && vSeries.length > 0"
          :colors="['#fcba03']"
          :height="150"
          ytitle="V"
          :library="{
            scales: {
              xAxes: [
                {
                  type: 'time', time: { unit: 'hour', displayFormats: { hour: 'MMM DD HH:mm' } },
                  ticks: {
                    fontColor: '#000000',
                  },
                },
              ],
              yAxes: [
                {
                  ticks: {
                    fontColor: '#000000',
                  },
                },
              ],
            },
          }"
          :data="vSeries"
        ></line-chart>
        <line-chart
          v-if="ovfSeries && ovfSeries.length > 0"
          :colors="['#fcba03']"
          :height="150"
          ytitle="Overflow"
          :library="{
            scales: {
              xAxes: [
                {
                  type: 'time', time: { unit: 'hour', displayFormats: { hour: 'MMM DD HH:mm' } },
                  ticks: {
                    fontColor: '#000000',
                  },
                },
              ],
              yAxes: [
                {
                  ticks: {
                    fontColor: '#000000',
                  },
                },
              ],
            },
          }"
          :data="ovfSeries"
        ></line-chart>
        <line-chart
          v-if="postTimeSeries && postTimeSeries.length > 0"
          :colors="['#fcba03']"
          :height="150"
          ytitle="POST time"
          :library="{
            scales: {
              xAxes: [
                {
                  type: 'time', time: { unit: 'hour', displayFormats: { hour: 'MMM DD HH:mm' } },
                  ticks: {
                    fontColor: '#000000',
                  },
                },
              ],
              yAxes: [
                {
                  ticks: {
                    fontColor: '#000000',
                  },
                },
              ],
            },
          }"
          :data="postTimeSeries"
        ></line-chart>
      </div>
      <!-- <v-expansion-panels>
          <v-expansion-panel>
            <v-expansion-panel-header>Text Warnings</v-expansion-panel-header>
            <v-expansion-panel-content
              v-for="item in haikuboxStatus"
              :key="item.id"
            >
              <template v-if="item.warning != ''">
                Date: {{ item.createdAt }}
                {{ item.warning }}
              </template>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels> -->
    </v-card>
    <v-container fluid>
      <v-row dense>
        <v-btn color="yellow" plain v-if="hitsLoading > 0">
            {{ "Loading" }} {{ hitsLoading }}</v-btn
          >

          <!-- Calendar Picker -->
          <v-btn
            fab
            small
            class="pa-1 ma-1"
            :color="recentHours == 0 ? 'blue lighten-2' : 'grey'"
            @click="hitSelectDate()"
            ><v-icon alt="calendar">mdi-calendar</v-icon>
          </v-btn>

          <template v-if="hitCalendarDatePicked == false">
        <v-row justify="center">
          <v-date-picker
            v-model="hitDatePicker"
            @change="hitDateClick()"
          ></v-date-picker>
        </v-row>
      </template>
      </v-row>

      <!-- Bat detections section -->
      <v-container v-if="hits.filter(h => h.cn === 'Bat').length > 0">
        <v-card color="purple darken-3" dark class="mb-4">
          <v-card-title>Bat Detections</v-card-title>
        </v-card>
        <v-row dense>
          <v-col
            cols="12"
            xs="12"
            sm="6"
            md="6"
            lg="4"
            xl="3"
            v-for="item in hits.filter(h => h.cn === 'Bat')"
            :key="'bat-' + item.id"
          >
            <v-card
              color="purple darken-2"
              class="mx-auto mx-auto"
              style="word-break: break-word"
              dark
            >
              <v-card-title>{{ item.cn }}</v-card-title>
              <v-card-subtitle class="font-italic">{{
                item.sn
              }}</v-card-subtitle>

              <v-row justify="end" class="px-8 my-0">
                <v-switch
                  dense
                  class="mr-5 py-0"
                  v-model="item.notifyBird"
                  v-tooltip.bottom-start="
                    'Send notification when this species is detected'
                  "
                  label="Notify"
                  color="info"
                  disabled
                ></v-switch>

                <v-switch
                  dense
                  class="py-0"
                  v-model="item.showBird"
                  v-tooltip.bottom-start="
                    'Turning Show OFF will hide this species on M and H setting'
                  "
                  :label="'Show'"
                  color="info"
                  disabled
                ></v-switch>
              </v-row>

              <!-- Recent Image -->
              <v-card-subtitle class="py-0">
                <img
                  width="100%"
                  v-if="item.window == 'image'"
                  :src="getImageUrl(item.spCode)"
                  onerror="this.onerror=null;this.src='https://haikubox-images.s3.amazonaws.com/placeholder.jpeg';"
                />

                <!-- Recent 24 Hour Donut Chart -->
                <div v-if="item.window == 'daily'">
                  <fusioncharts
                    type="doughnut2d"
                    width="100%"
                    height="240"
                    dataFormat="json"
                    :dataSource="item.hourlyCountPlotData"
                  >
                  </fusioncharts>
                </div>
                <!-- Recent 14 day heat map -->
                <div v-if="item.window == 'heatmap'">
                  <Plotly
                    :data="item.heatmap"
                    :display-mode-bar="false"
                    :layout="plotlyLayoutHeatmap"
                  ></Plotly>
                </div>

                <!-- Recent Daily Time Series -->
                <div v-if="item.window == 'monthly'">
                  <v-card-text class="ma-3"
                    ><v-icon>mdi-music-note</v-icon>
                    Past 3 Months
                  </v-card-text>
                  <column-chart
                    :colors="['#90A4AE']"
                    :height="300"
                    :library="{
                      scales: {
                        xAxes: [
                          {
                            ticks: {
                              fontColor: '#ffffff',
                            },
                          },
                        ],
                        yAxes: [
                          {
                            ticks: {
                              fontColor: '#ffffff',
                            },
                          },
                        ],
                      },
                    }"
                    :data="item.dailyCountPlotData"
                  ></column-chart>
                </div>

                <!-- Recent Spectrogram -->
                <div v-if="item.window == 'spectrogram'">
                  <Plotly
                    :data="item.spectrogram"
                    :layout="plotlyLayout"
                    :display-mode-bar="false"
                  ></Plotly>
                  <v-row no-gutters>
                    <v-col cols="2" class="text-caption">{{
                      item.windowStart
                        ? item.windowStart.toFixed(1) + "s"
                        : "0s"
                    }}</v-col>
                    <v-col cols="8"></v-col>
                    <v-col cols="2" class="d-flex justify-end text-caption">{{
                      item.windowEnd
                        ? item.windowEnd.toFixed(1) + "s"
                        : clipSeconds + "s"
                    }}</v-col>
                  </v-row>
                </div>

                <!-- Recent Map -->
                <div v-if="item.window == 'map'">
                  <l-map
                    :center="center"
                    :options="hitMapOptions"
                    :bounds="bounds"
                    style="height: 240px; width: 100%"
                    @update:center="centerUpdate"
                    @update:zoom="zoomUpdate"
                    :zoomControl="false"
                    :zoom="zoom"
                    :maxZoom="maxZoomHitMap"
                  >
                    <l-tile-layer
                      :url="urlSummary"
                      :attribution="attributionSummary"
                    />
                    <l-circle
                      v-for="countPerHaikubox in item.map"
                      :key="countPerHaikubox.id"
                      :lat-lng="[countPerHaikubox.lat, countPerHaikubox.lon]"
                      :radius="countPerHaikubox.radius"
                      color="#0277BD"
                      fillColor="#039BE5"
                    />
                  </l-map>
                </div>
              </v-card-subtitle>

              <v-row class="my-0 py-0">
                <v-card-text class="my-0 py-0">
                  <v-btn
                    text
                    v-if="isBat(item)"
                    @click="navigateTo('https://www.batcon.org/about-bats/bats-101/')"
                    target="_blank"
                    color="light-blue"
                    >BCI</v-btn
                  >
                  <v-btn
                    text
                    v-if="!isBat(item)"
                    @click="navigateTo('https://ebird.org/species/' + item.spCode)"
                    target="_blank"
                    color="light-blue"
                    >eBird</v-btn
                  >
                </v-card-text>

                <v-spacer></v-spacer>
              </v-row>

              <!-- Recent Navigation -->
              <v-row class="mb-1" no-gutters>
                <v-col cols="8">
                  <v-avatar
                    class="ml-4"
                    size="24"
                    v-tooltip.bottom-start="'Image'"
                    @click="
                      setWindowRecent(hits.indexOf(item), 'image', item.spCode, item.cn)
                    "
                  >
                    <img
                      :width="$vuetify.breakpoint.xs ? '100%' : '320'"
                      :src="
                        'https://haikubox-images.s3.amazonaws.com/' +
                        item.spCode +
                        '.jpeg'
                      "
                      onerror="this.onerror=null;this.src='https://haikubox-images.s3.amazonaws.com/placeholder.jpeg';"
                    />
                  </v-avatar>

                  <v-btn
                    icon
                    class="ml-0"
                    v-tooltip.bottom-start="'Hourly Chart'"
                    @click="
                      setWindowRecent(hits.indexOf(item), 'daily', item.spCode, item.cn)
                    "
                    v-if="recentHours != 0"
                  >
                    <v-icon alt="hourly chart">mdi-chart-donut</v-icon>
                  </v-btn>
                  <v-btn
                    icon
                    class="ml-0"
                    v-tooltip.bottom-start="'Daily Chart'"
                    @click="
                      setWindowRecent(hits.indexOf(item), 'monthly', item.spCode, item.cn)
                    "
                  >
                    <v-icon alt="daily chart">mdi-chart-bar</v-icon>
                  </v-btn>
                  <v-btn
                    icon
                    class="ml-0"
                    v-tooltip.bottom-start="'Heat Map'"
                    @click="
                      setWindowRecent(hits.indexOf(item), 'heatmap', item.spCode, item.cn)
                    "
                  >
                    <v-icon alt="heat map">mdi-checkerboard</v-icon>
                  </v-btn>
                  <v-btn
                    icon
                    class="ml-0"
                    v-tooltip.bottom-start="'Map'"
                    @click="setWindowRecent(hits.indexOf(item), 'map', item.spCode, item.cn)"
                    v-if="recentHours != 0"
                  >
                    <v-icon alt="map">mdi-earth</v-icon>
                  </v-btn>
                  <v-btn
                    icon
                    class="ml-0"
                    v-tooltip.bottom-start="'Spectrogram'"
                    @click="
                      spectrogram(hits.indexOf(item), item.currentWav['filename'], 'Recent')
                    "
                  >
                    <v-icon alt="spectrogram">mdi-chart-bubble</v-icon>
                  </v-btn>
                </v-col>
              </v-row>

              <!-- Recent Play -->
              <div>
                <v-card-actions class="mx-0 my-0 py-0">
                  <v-row
                    ><v-col cols="12">
                      <v-btn
                        class="mx-1 my-1"
                        @click="
                          playFile(
                            item.currentWav['filename'],
                            item.spCode,
                            item.cn,
                            item,
                            hits.indexOf(item),
                            false
                          )
                        "
                        color="light-blue darken-1"
                      >
                        <v-icon left>mdi-play-circle</v-icon>
                        <v-divider class="mx-1" vertical></v-divider>
                        {{"Play" }}
                      </v-btn>
                      <v-btn
                        class="mx-1"
                        @click="
                          playFileEnhance(
                            item.currentWav['filename'],
                            item.spCode,
                            item.cn,
                            item.id
                          )
                        "
                        color="light-blue darken-1"
                      >
                        <v-icon left>mdi-play-circle</v-icon>
                        <v-divider class="mx-1" vertical></v-divider>
                        {{ item.cn === 'Bat' ? 'Pitch Shift' : 'Enhance' }}
                      </v-btn>

                      <!-- Clip length controls for files longer than 3s -->
                      <v-chip
                        v-if="maxClipSeconds > 3 && isLongClipFile(item)"
                        class="mx-2"
                        small
                        color="light-blue darken-1"
                      >
                        <v-btn
                          icon
                          x-small
                          @click="updateClipSeconds(-3)"
                          :disabled="clipSeconds <= 3"
                          class="mr-1"
                        >
                          <v-icon small>mdi-minus</v-icon>
                        </v-btn>
                        {{ clipSeconds }}s
                        <v-btn
                          icon
                          x-small
                          @click="updateClipSeconds(3)"
                          :disabled="clipSeconds >= maxClipSeconds"
                          class="ml-1"
                        >
                          <v-icon small>mdi-plus</v-icon>
                        </v-btn>
                      </v-chip>
                      </v-col
                    >
                    <v-col cols="10">
                      <v-select
                        class="mx-2 my-0 py-0"
                        :items="item.wavList"
                        v-model="item.currentWav"
                        item-text="listname"
                        item-value="filename"
                        @change="
                          playFile(
                            item.currentWav['filename'],
                            item.spCode,
                            item.cn,
                            item,
                            hits.indexOf(item),
                            true
                          );
                          if (item.window === 'spectrogram') {
                            spectrogram(hits.indexOf(item), item.currentWav['filename'], 'Recent');
                          }
                        "
                        return-object
                        single-line
                      ></v-select>
                    </v-col>
                    <v-col cols="2">
                      <v-btn
                        class="mx-0 my-0"
                        color="light-blue darken-1"
                        fab
                        small
                        dark
                        v-tooltip.bottom-start="'Download'"
                        @click="download(item)"
                        ><v-icon alt="download">mdi-download</v-icon>
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-card-actions>
              </div>
            </v-card>
          </v-col>
        </v-row>
      </v-container>

      <!-- Recent hits -->
      <v-container>
        <v-row dense>
          <v-col
            cols="12"
            xs="12"
            sm="6"
            md="6"
            lg="4"
            xl="3"
            v-for="(item, index) in hits"
            :key="item.id"
          >
            <v-card
              color="light-blue darken-4"
              class="mx-auto mx-auto"
              style="word-break: break-word"
              dark
            >
              <v-card-title>{{ item.cn }}</v-card-title>
              <v-card-subtitle class="font-italic">{{
                item.sn
              }}</v-card-subtitle>

              <v-row justify="end" class="px-8 my-0">
                <v-switch
                  dense
                  class="mr-5 py-0"
                  v-model="item.notifyBird"
                  v-tooltip.bottom-start="
                    'Send notification when this species is detected'
                  "
                  label="Notify"
                  color="info"
                  disabled
                ></v-switch>

                <v-switch
                  dense
                  class="py-0"
                  v-model="item.showBird"
                  v-tooltip.bottom-start="
                    'Turning Show OFF will hide this species on M and H setting'
                  "
                  :label="'Show'"
                  color="info"
                  disabled
                ></v-switch>
              </v-row>

              <!-- Recent Image -->
              <v-card-subtitle class="py-0">
                <img
                  width="100%"
                  v-if="item.window == 'image'"
                  :src="getImageUrl(item.spCode)"
                  onerror="this.onerror=null;this.src='https://haikubox-images.s3.amazonaws.com/placeholder.jpeg';"
                />

                <!-- Recent 24 Hour Donut Chart -->
                <div v-if="item.window == 'daily'">
                  <fusioncharts
                    type="doughnut2d"
                    width="100%"
                    height="240"
                    dataFormat="json"
                    :dataSource="item.hourlyCountPlotData"
                  >
                  </fusioncharts>
                </div>
                <!-- Recent 14 day heat map -->
                <div v-if="item.window == 'heatmap'">
                  <Plotly
                    :data="item.heatmap"
                    :display-mode-bar="false"
                    :layout="plotlyLayoutHeatmap"
                  ></Plotly>
                </div>

                <!-- Recent Daily Time Series -->
                <div v-if="item.window == 'monthly'">
                  <v-card-text class="ma-3"
                    ><v-icon>mdi-music-note</v-icon>
                    Past 3 Months

                    <!-- <span
                      class="font-weight-white"
                      v-text="getDailySpeciesCount(item.cn)"
                    ></span> -->
                  </v-card-text>
                  <column-chart
                    :colors="['#90A4AE']"
                    :height="300"
                    :library="{
                      scales: {
                        xAxes: [
                          {
                            ticks: {
                              fontColor: '#ffffff',
                            },
                          },
                        ],
                        yAxes: [
                          {
                            ticks: {
                              fontColor: '#ffffff',
                            },
                          },
                        ],
                      },
                    }"
                    :data="item.dailyCountPlotData"
                  ></column-chart>
                </div>

                <!-- Recent Spectrogram -->
                <div v-if="item.window == 'spectrogram'">
                  <Plotly
                    :data="item.spectrogram"
                    :layout="plotlyLayout"
                    :display-mode-bar="false"
                  ></Plotly>
                  <v-row no-gutters>
                    <v-col cols="2" class="text-caption">{{
                      item.windowStart
                        ? item.windowStart.toFixed(1) + "s"
                        : "0s"
                    }}</v-col>
                    <v-col cols="8"></v-col>
                    <v-col cols="2" class="d-flex justify-end text-caption">{{
                      item.windowEnd
                        ? item.windowEnd.toFixed(1) + "s"
                        : clipSeconds + "s"
                    }}</v-col>
                  </v-row>
                </div>

                <!-- Recent Map -->
                <div v-if="item.window == 'map'">
                  <l-map
                    :center="center"
                    :options="hitMapOptions"
                    :bounds="bounds"
                    style="height: 240px; width: 100%"
                    @update:center="centerUpdate"
                    @update:zoom="zoomUpdate"
                    :zoomControl="false"
                    :zoom="zoom"
                    :maxZoom="maxZoomHitMap"
                  >
                    <l-tile-layer
                      :url="urlSummary"
                      :attribution="attributionSummary"
                    />
                    <l-circle
                      v-for="countPerHaikubox in item.map"
                      :key="countPerHaikubox.id"
                      :lat-lng="[countPerHaikubox.lat, countPerHaikubox.lon]"
                      :radius="countPerHaikubox.radius"
                      color="#0277BD"
                      fillColor="#039BE5"
                    />
                  </l-map>
                </div>
              </v-card-subtitle>

              <v-row class="my-0 py-0">
                <v-card-text class="my-0 py-0">
                  <!-- <v-btn
                    text
                    v-if="item.lon < -30"
                    :href="
                      item.lon > -30
                        ? 'https://ebird.org/species/' + item.spCode
                        : 'https://www.allaboutbirds.org/guide/' +
                          replaceSpaces(item.cn)
                    "
                    target="_blank"
                    color="light-blue"
                    >{{ "About" }}</v-btn
                  > -->
                  <v-btn
                    text
                    v-if="isBat(item)"
                    @click="navigateTo('https://www.batcon.org/about-bats/bats-101/')"
                    target="_blank"
                    color="light-blue"
                    >BCI</v-btn
                  >
                  <v-btn
                    text
                    v-if="!isBat(item)"
                    @click="navigateTo('https://ebird.org/species/' + item.spCode)"
                    target="_blank"
                    color="light-blue"
                    >eBird</v-btn
                  >
                </v-card-text>

                <v-spacer></v-spacer>
              </v-row>

              <!-- Recent Navigation -->
              <v-row class="mb-1" no-gutters>
                <v-col cols="8">
                  <v-avatar
                    class="ml-4"
                    size="24"
                    v-tooltip.bottom-start="'Image'"
                    @click="
                      setWindowRecent(index, 'image', item.spCode, item.cn)
                    "
                  >
                    <img
                      :width="$vuetify.breakpoint.xs ? '100%' : '320'"
                      :src="
                        'https://haikubox-images.s3.amazonaws.com/' +
                        item.spCode +
                        '.jpeg'
                      "
                      onerror="this.onerror=null;this.src='https://haikubox-images.s3.amazonaws.com/placeholder.jpeg';"
                    />
                  </v-avatar>

                  <v-btn
                    icon
                    class="ml-0"
                    v-tooltip.bottom-start="'Hourly Chart'"
                    @click="
                      setWindowRecent(index, 'daily', item.spCode, item.cn)
                    "
                    v-if="recentHours != 0"
                  >
                    <v-icon alt="hourly chart">mdi-chart-donut</v-icon>
                  </v-btn>
                  <v-btn
                    icon
                    class="ml-0"
                    v-tooltip.bottom-start="'Daily Chart'"
                    @click="
                      setWindowRecent(index, 'monthly', item.spCode, item.cn)
                    "
                  >
                    <v-icon alt="daily chart">mdi-chart-bar</v-icon>
                  </v-btn>
                  <v-btn
                    icon
                    class="ml-0"
                    v-tooltip.bottom-start="'Heat Map'"
                    @click="
                      setWindowRecent(index, 'heatmap', item.spCode, item.cn)
                    "
                  >
                    <v-icon alt="heat map">mdi-checkerboard</v-icon>
                  </v-btn>
                  <v-btn
                    icon
                    class="ml-0"
                    v-tooltip.bottom-start="'Map'"
                    @click="setWindowRecent(index, 'map', item.spCode, item.cn)"
                    v-if="recentHours != 0"
                  >
                    <v-icon alt="map">mdi-earth</v-icon>
                  </v-btn>
                  <v-btn
                    icon
                    class="ml-0"
                    v-tooltip.bottom-start="'Spectrogram'"
                    @click="
                      spectrogram(index, item.currentWav['filename'], 'Recent')
                    "
                  >
                    <v-icon alt="spectrogram">mdi-chart-bubble</v-icon>
                  </v-btn>
                </v-col>
              </v-row>

              <!-- Recent Play -->
              <div>
                <v-card-actions class="mx-0 my-0 py-0">
                  <v-row
                    ><v-col cols="12">
                      <v-btn
                        class="mx-1 my-1"
                        @click="
                          playFile(
                            item.currentWav['filename'],
                            item.spCode,
                            item.cn,
                            item,
                            index,
                            false
                          )
                        "
                        color="light-blue darken-1"
                      >
                        <v-icon left>mdi-play-circle</v-icon>
                        <v-divider class="mx-1" vertical></v-divider>
                        {{"Play" }}
                      </v-btn>
                      <v-btn
                        class="mx-1"
                        @click="
                          playFileEnhance(
                            item.currentWav['filename'],
                            item.spCode,
                            item.cn,
                            item.id
                          )
                        "
                        color="light-blue darken-1"
                      >
                        <v-icon left>mdi-play-circle</v-icon>
                        <v-divider class="mx-1" vertical></v-divider>
                        {{ item.cn === 'Bat' ? 'Pitch Shift' : 'Enhance' }}
                      </v-btn>

                      <!-- Clip length controls for files longer than 3s -->
                      <v-chip
                        v-if="maxClipSeconds > 3 && isLongClipFile(item)"
                        class="mx-2"
                        small
                        color="light-blue darken-1"
                      >
                        <v-btn
                          icon
                          x-small
                          @click="updateClipSeconds(-3)"
                          :disabled="clipSeconds <= 3"
                          class="mr-1"
                        >
                          <v-icon small>mdi-minus</v-icon>
                        </v-btn>
                        {{ clipSeconds }}s
                        <v-btn
                          icon
                          x-small
                          @click="updateClipSeconds(3)"
                          :disabled="clipSeconds >= maxClipSeconds"
                          class="ml-1"
                        >
                          <v-icon small>mdi-plus</v-icon>
                        </v-btn>
                      </v-chip>
                      </v-col
                    >
                    <v-col cols="10">
                      <v-select
                        class="mx-2 my-0 py-0"
                        :items="item.wavList"
                        v-model="item.currentWav"
                        item-text="listname"
                        item-value="filename"
                        @change="
                          playFile(
                            item.currentWav['filename'],
                            item.spCode,
                            item.cn,
                            item,
                            index,
                            true
                          );
                          if (item.window === 'spectrogram') {
                            spectrogram(index, item.currentWav['filename'], 'Recent');
                          }
                        "
                        return-object
                        single-line
                      ></v-select>
                    </v-col>
                    <v-col cols="2">
                      <v-btn
                        class="mx-0 my-0"
                        color="light-blue darken-1"
                        fab
                        small
                        dark
                        v-tooltip.bottom-start="'Download'"
                        @click="download(item)"
                        ><v-icon alt="download">mdi-download</v-icon>
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-card-actions>
              </div>
            </v-card>
          </v-col>
        </v-row>
      </v-container>

    </v-container>
  </v-container>
</template>

<script>
import { API, Storage } from "aws-amplify";
import {
  statusByDate,
  haikuboxByType,
  bootBySerialByDate,
  hitBySerialByDate,
  haikuboxByOwner,
  haikuboxUserByEmail,
  listHaikuboxUsers,
  getNoticeDescription,
  deviceHistoryByDate,
  deviceHistoryBySerial,
  getOneSignalConsent,
  getHaikuboxUser,
  getDevice,
  getDeviceState,
  getSubscription,
  hideBirdBySerial,
  notifyBirdBySerial,
  getFavoriteHit,
  dailyCountSummaryByDateBySpecies,
  getAudioUrl,
  hitsBySpeciesByDate,
  dailyCountSummaryBySerialBySpecies,
  getGridByLoc
} from "../graphql/queries";
// import { createUserNotice } from "../graphql/mutations";
import { createLabeledData } from "../graphql/mutations";
var moment = require("moment-timezone");
var tzlookup = require("tz-lookup");
import { LCircle } from "vue2-leaflet";
import { latLng, latLngBounds } from "leaflet";
// import FusionCharts from "fusioncharts";
import { Plotly } from "vue-plotly";
// https://github.com/chrisguttandin/standardized-audio-context
import { AudioContext, decodeAudioData } from "standardized-audio-context";
//const AudioContext = window.AudioContext || window.webkitAudioContext;

var fft = require("fft-js").fft,
  ifft = require("fft-js").ifft;
import { FFT } from "dsp.js";
import { unmute } from "../unmute.min.js";
let globalAudioContext = null;
let globalGainNode = null;

export default {
  props: ["user"],
  created() {
  },
  components: {
    Plotly,
    LCircle,
  },
  data() {
    return {
      haikubox: "",
      serialInput: "",
      emailInput: "",
      userNotFound: false,
      deviceState: null,
      deviceStateQueried: false,
      expandedDeviceState: null,
      expandedDeviceStateLoading: false,
      deviceHistoryPanel: undefined,
      deviceHistoryLoaded: false,
      deviceStatuses: {},
      deviceStatusKey: 0,
      expandedDevices: [],
      noticeId: "",
      noticeDescription: "",
      usersList: [],
      haikuboxList: [],
      allDevicesList: [],
      haikuboxListLoading: false,
      haikuboxListProgress: 0,
      haikuboxProps: [],
      subscriptionProps: [],
      haikuboxHeaders: [
        {
          text: "Name",
          align: "start",
          sortable: true,
          value: "name",
        },
        { text: "Serial", value: "serial" },
        { text: "Owner", value: "owner" },
        { text: "New Bird Alert", value: "newBirdAlert" },
        { text: "Hide", value: "hideOnMap" },
        { text: "Lat", value: "lat" },
        { text: "Lon", value: "lon" },
        { text: "Share Cornell", value: "shareBird" },
        { text: "Created", value: "createdAt" },
        { text: "Updated", value: "updatedAt" },
      ],
      historyHeaders: [
        {
          text: "Name",
          align: "start",
          sortable: true,
          value: "name",
        },
        { text: "Serial", value: "serial" },
        { text: "Version", value: "version" },
        { text: "Type", value: "deviceType" },
        { text: "Owner", value: "owner" },
        { text: "Lat", value: "lat" },
        { text: "Lon", value: "lon" },
        { text: "Share Cornell/NABat", value: "shareBird" },
        { text: "Created", value: "createdAt" },
      ],
      mergedDeviceHeaders: [
        { text: "", value: "data-table-expand" },
        { text: "Name", align: "start", sortable: true, value: "name" },
        { text: "Serial", value: "serial" },
        { text: "Version", value: "version" },
        { text: "WiFi", value: "wifiSignal", align: "center" },
        { text: "Sub Type", value: "prepaidType" },
        { text: "Source", value: "subSource" },
        { text: "Prepaid End", value: "prepaidPeriodEndUnix" },
        { text: "Stripe End", value: "stripeCurrentPeriodEndUnix" },
        { text: "Apple End", value: "applePeriodEndUnix" },
      ],
      deviceHistory: [],
      serialHistory: [],
      serialHistoryLoading: false,
      serialHistoryHeaders: [
        { text: "Date", value: "createdAtDisplay" },
        { text: "Action", value: "deviceAction" },
        { text: "Changes", value: "changes" },
        { text: "Name", value: "name" },
        { text: "Owner", value: "owner" },
        { text: "Share", value: "shareBird" },
        { text: "Lat", value: "lat" },
        { text: "Lon", value: "lon" },
      ],
      userIdList: [],
      cpuTempSeries: [],
      cpuFreqSeries: [],
      ramdiskSeries: [],
      signalSeries: [],
      nDirectSeries: [],
      nCloudSeries: [],
      freeGbSeries: [],
      vSeries: [],
      ovfSeries: [],
      postTimeSeries: [],
      bootTable: [],
      getUsersByEmail: null,
      emailSearchTimeout: null,
      emailSearching: false,
      currentWiFi: 0,
      firmwareVersion: 0,
      gridSpecies: [],
      gridWeek: 0,
      gridLoading: false,
      timezone: "",
      currentSerial: "",
      hits: [],
      recentHours: 24,
      playbackGain: 1,
      clipSeconds: 3,
      maxClipSeconds: 3,
      audioContexts: new Map(),
      // Map-related properties
      urlSummary: "https://server.arcgisonline.com/ArcGIS/rest/services/World_Shaded_Relief/MapServer/tile/{z}/{y}/{x}",
      urlStates: "https://server.arcgisonline.com/ArcGIS/rest/services/NatGeo_World_Map/MapServer/tile/{z}/{y}/{x}",
      maxZoomHitMap: 7,
      attributionSummary: "Tiles &copy; Esri &mdash; Source: US National Park Service",
      zoom: 3,
      center: latLng(39, -94),
      hitMapOptions: {
        zoomControl: false,
      },
      bounds: latLngBounds([
        [20, -120],
        [55, -70],
      ]),
      currentZoom: 3,
      currentCenter: latLng(39, -94),
      fftLength: 512,
      halfLength: 256,
      customHiddenList: [],
      hitsLoading: 0,
      selectedLanguage: "en",
      currentTimezone: "America/New_York",
      currentView: "Recent",
      email: "",
      userID: "",
      lat: 0.0,
      lon: 0.0,
      confirmedEmail: null,
      accountUpdatedAt: null,
      numHaikuboxes: null,
      oneSignalConsentGranted: false,
      hitCalendarDatePicked: true,
      hitDatePicker: new Date(
        Date.now() - new Date().getTimezoneOffset() * 60000
      )
        .toISOString()
        .substr(0, 10),
      chartOptionsHourly: {
        xaxis: {
          categories: [],
        },
      },
      chartOptionsSpeciesHourly: {
        xaxis: {
          categories: [],
        },
      },
      fusionSchema: [
        {
          name: "Time",
          type: "date",
          format: "%Y-%m-%d %H:%M",
        },
        {
          name: "Detections",
          type: "number",
        },
      ],
      fusionSchemaDaily: [
        {
          name: "Date",
          type: "date",
          format: "%Y-%m-%d",
        },
        {
          name: "Detections",
          type: "number",
        },
      ],
      dataSource: {
        data: null,
        legend: {
          enabled: "0",
        },
        navigator: {
          enabled: 0,
        },
        caption: {
          text: "Detections",
        },
        subcaption: {
          text: "All Species",
        },
        extensions: {
          customRangeSelector: {
            enabled: "0",
          },
        },
        yAxis: [
          {
            plot: {
              value: "Detections",
              type: "column",
            },
            format: {
              prefix: "",
            },
            title: "Avg/15 minutes",
          },
        ],
      },
      plotlyLayoutHeatmap: {
        xaxis: {
          autorange: true,
          showgrid: false,
          zeroline: false,
          showline: false,
          autotick: true,
          ticks: "",
          showticklabels: true,
          fixedrange: true,
        },
        yaxis: {
          autorange: true,
          showgrid: false,
          zeroline: false,
          showline: false,
          autotick: true,
          ticks: "",
          showticklabels: true,
          fixedrange: true,
        },
        title: "Calls Per Hour",
        margin: {
          l: 60,
          r: 40,
          b: 60,
          t: 40,
          pad: 4,
        },
        height: 300,
        hovermode: false,
      },
      plotlyLayout: {
        xaxis: {
          autorange: true,
          showgrid: false,
          zeroline: false,
          showline: false,
          autotick: true,
          ticks: "",
          showticklabels: false,
          fixedrange: true,
        },
        yaxis: {
          autorange: true,
          showgrid: false,
          zeroline: false,
          showline: false,
          autotick: true,
          ticks: "",
          showticklabels: false,
          fixedrange: true,
        },
        margin: {
          l: 0,
          r: 0,
          b: 0,
          t: 0,
          pad: 4,
        },
        height: 240,
        hovermode: false,
      },
    };
  },
  watch: {
    getUsersByEmail(val) {
      // Debounce typing - press Enter for immediate search
      clearTimeout(this.emailSearchTimeout);
      if (!val || val.length < 3) {
        this.usersList = [];
        return;
      }
      this.emailSearchTimeout = setTimeout(() => {
        this.searchUsersByEmail(val);
      }, 500);
    },
  },
  computed: {
    mergedDeviceData() {
      return this.haikuboxProps.map(device => {
        const sub = this.subscriptionProps.find(s => s.id === device.serial) || {};
        return {
          ...device,
          lat: device.lat ? Number(device.lat).toFixed(2) : '',
          lon: device.lon ? Number(device.lon).toFixed(2) : '',
          version: device.statusVersion || device.version || '',
          lastReported: device.statusLastReported || '',
          lastReportedMinutes: device.statusLastReportedMinutes != null ? device.statusLastReportedMinutes : -1,
          wifiSignal: device.statusWifiSignal != null ? device.statusWifiSignal : '',
          createdAt: device.createdAt ? moment.utc(device.createdAt).format("YYYY-MM-DD") : '',
          updatedAt: device.updatedAt ? moment.utc(device.updatedAt).format("YYYY-MM-DD") : '',
          diagnosis: device.statusDiagnosis || '',
          prepaidType: sub.prepaidType || '',
          prepaidPeriodEndUnix: sub.prepaidPeriodEndUnix || '',
          stripeCurrentPeriodEndUnix: sub.stripeCurrentPeriodEndUnix || '',
          subOwner: sub.owner || '',
          subOwnerMismatch: sub.owner ? sub.owner !== device.owner : false,
          autoRenew: sub.autoRenew || '',
          stripeCustomer: sub.stripeCustomer || '',
          applePeriodEndUnix: sub.applePeriodEndUnix || '',
          appleAutoRenew: sub.appleAutoRenew != null ? sub.appleAutoRenew : '',
          appleOriginalTransactionId: sub.appleOriginalTransactionId || '',
          // Which channel is actually paying for this device
          subSource: sub.appleOriginalTransactionId
            ? 'Apple'
            : sub.stripeCustomer
            ? 'Stripe'
            : sub.prepaidType
            ? 'Prepaid'
            : '',
        };
      });
    },
    serialHistoryRows() {
      // Oldest -> newest to compute per-record diffs, then newest first for display
      const sorted = [...this.serialHistory].sort((a, b) =>
        moment(a.createdAt).diff(moment(b.createdAt))
      );
      const tracked = ["name", "owner", "shareBird", "lat", "lon"];
      const rows = sorted.map((item, i) => {
        let changes = "";
        if (i === 0) {
          changes = item.deviceAction === "INSERT" ? "created" : "";
        } else {
          const prev = sorted[i - 1];
          changes = tracked
            .filter((f) => String(prev[f]) !== String(item[f]))
            .map((f) => `${f}: ${prev[f]} → ${item[f]}`)
            .join(", ");
        }
        return {
          ...item,
          createdAtDisplay: moment(item.createdAt).format("YYYY-MM-DD HH:mm"),
          lat: item.lat != null ? Number(item.lat).toFixed(3) : "",
          lon: item.lon != null ? Number(item.lon).toFixed(3) : "",
          changes,
        };
      });
      return rows.reverse();
    },
    filteredDeviceHistory() {
      // Filter to only show INSERT actions and add device type
      return this.deviceHistory
        .filter(item => item.deviceAction === 'INSERT')
        .map(item => ({
          ...item,
          deviceType: this.getDeviceTypeFromVersion(item.version),
          lat: item.lat ? Number(item.lat).toFixed(1) : '',
          lon: item.lon ? Number(item.lon).toFixed(1) : ''
        }));
    },
    isBatDevice() {
      const version = String(this.firmwareVersion || '');
      if (!version || version === '0') return null;

      // Version 5.x and 6.3.1 are explicitly bird versions
      if (version.startsWith('5.') || version === '6.3.1') {
        return false;
      }

      // Version 2.0.x with direct detections indicates bat device
      if (version.startsWith('2.0.')) {
        // Check if there are any direct detections
        const hasDirectDetections = this.nDirectSeries && this.nDirectSeries.length > 0 &&
                                    this.nDirectSeries.some(entry => entry[1] > 0);
        return hasDirectDetections;
      }

      return null; // Unknown/indeterminate
    },
    deviceTypeLabel() {
      // Chip is driven by deviceState.batCapable only — no guessing.
      // Missing fields are shown as missing until the table is backfilled.
      if (!this.deviceStateQueried) return '';
      const ds = this.deviceState;
      if (!ds) return 'no deviceState';
      const typePrefix = ds.type ? `${ds.type}: ` : 'type?: ';
      if (ds.batCapable === true) return typePrefix + 'bat';
      if (ds.batCapable === false) return typePrefix + 'bird';
      return typePrefix + 'batCapable?';
    },
    deviceTypeColor() {
      const ds = this.deviceState;
      if (!ds || ds.batCapable == null) return 'grey';
      return ds.batCapable ? 'purple' : 'green';
    },
    directChartLabel() {
      // For bat devices, show "# bat", otherwise "# Direct"
      return this.isBatDevice === true ? '# bat' : '# Direct';
    },
    cloudChartLabel() {
      // For bat devices, show "# bird", otherwise "# Cloud"
      return this.isBatDevice === true ? '# bird' : '# Cloud';
    },
    dropdown_class() {
      const text = ["Yes","No","No it's a ...", "Not Sure"];
      // console.log(text);
      return text;
    },
    navList() {
      if (this.subscriptionActive == false) {
        return [
          {
            id: "Last 2 Hours",
            text: "Last 2 Hours",
            icon: "mdi-clock-outline",
          },
          {
            id: "Resubscribe",
            text: "ResubscribeInfo",
            icon: "mdi-meteor",
          },
        ];
      } else {
        return [
          {
            id: "Last 2 Hours",
            text: "Last 2 Hours",
            icon: "mdi-clock-outline",
          },
          {
            id: "Last 12 Hours",
            text: "Last 12 Hours",
            icon: "mdi-clock-outline",
          },
          {
            id: "Last 24 Hours",
            text: "Last 24 Hours",
            icon: "mdi-clock-outline",
          },
          {
            id: "Yesterday",
            text: "Yesterday",
            icon: "mdi-calendar-clock",
          },
          { id: "Live", text: "Live", icon: "mdi-meteor" },
          { id: "All", text: "All", icon: "mdi-ballot-outline" },
        ];
      }
    },
  },
  methods: {
    getDeviceTypeFromVersion(version) {
      const versionStr = String(version || '');
      if (!versionStr || versionStr === '0') return '?';

      // Version 5.x and 6.3.1 are explicitly bird versions
      if (versionStr.startsWith('5.') || versionStr === '6.3.1') {
        return 'Bird';
      }

      // Version 2.0.x indicates bat device (we can't check direct detections here)
      if (versionStr.startsWith('2.0.')) {
        return 'Bat';
      }

      return '?';
    },
    isLongClipFile(item) {
      // Check if this item's file supports clips longer than 3s
      const wav = item.wav || '';
      // P files (position 5), p files (starts with p), or marine files (contains M)
      if (wav[5] === "P" || wav[0] === "p" || wav.includes("M")) {
        return true;
      }
      // Backblaze files (starts with bb/) support long clips, except bat files
      if (wav.startsWith("bb/") && item.cn !== 'Bat') {
        return true;
      }
      return false;
    },
    updateClipSeconds(delta) {
      const newValue = this.clipSeconds + delta;
      if (newValue >= 3 && newValue <= this.maxClipSeconds) {
        this.clipSeconds = newValue;

        // Recalculate spectrograms for any items currently showing a spectrogram
        this.hits.forEach((item, index) => {
          if (item.window === 'spectrogram' && item.currentWav && item.currentWav.filename) {
            this.spectrogram(index, item.currentWav.filename, 'Recent');
          }
        });
      }
    },
    zoomUpdate(zoom) {
      this.currentZoom = Math.floor(zoom);
    },
    centerUpdate(center) {
      this.currentCenter = center;
    },
    async detectFlacSampleRate(arrayBuffer) {
      try {
        const view = new DataView(arrayBuffer);

        // Verify it's a FLAC file
        const magic = String.fromCharCode(
          view.getUint8(0),
          view.getUint8(1),
          view.getUint8(2),
          view.getUint8(3)
        );

        if (magic !== "fLaC") {
          console.warn("Not a FLAC file");
          return null;
        }

        // STREAMINFO block starts at byte 8
        // Sample rate is 20 bits starting at bit 80 (byte 18)
        const byte18 = view.getUint8(18);
        const byte19 = view.getUint8(19);
        const byte20 = view.getUint8(20);

        // Sample rate is 20 bits: all of byte18, all of byte19, top 4 bits of byte20
        const sampleRate = (byte18 << 12) | (byte19 << 4) | (byte20 >> 4);

        // console.log(`Detected FLAC native sample rate: ${sampleRate}Hz`);
        return sampleRate;
      } catch (error) {
        console.error("Error detecting FLAC sample rate:", error);
        return null;
      }
    },
    async getAudioSampleRate(arrayBuffer) {
      // Create a temporary context just to decode and get the sample rate
      const tempContext = new AudioContext();
      try {
        const audioBuffer = await decodeAudioData(
          tempContext,
          arrayBuffer.slice(0)
        );
        const sampleRate = audioBuffer.sampleRate;
        tempContext.close();
        return sampleRate;
      } catch (error) {
        tempContext.close();
        throw error;
      }
    },
    async getMatchingAudioContext(sampleRate) {
      // Check if we already have a context for this sample rate
      if (this.audioContexts.has(sampleRate)) {
        const context = this.audioContexts.get(sampleRate);
        if (context.state !== "closed") {
          return context;
        }
        // Remove stale closed context from cache
        this.audioContexts.delete(sampleRate);
      }

      // Create new context with matching sample rate
      try {
        const audioContext = new AudioContext({ sampleRate: sampleRate });
        this.audioContexts.set(sampleRate, audioContext);
        return audioContext;
      } catch (error) {
        console.warn(`Cannot create context at ${sampleRate}Hz, using default`);
        const audioContext = new AudioContext();
        this.audioContexts.set("default", audioContext);
        return audioContext;
      }
    },
    lookupEmail() {
      this.emailInput = (this.emailInput || '').toLowerCase().trim();
      this.email = this.emailInput;
      this.getDevicesByOwner();
    },
    onEmailEnter() {
      // When Enter is pressed, search immediately with exact match
      clearTimeout(this.emailSearchTimeout);
      if (this.getUsersByEmail && this.getUsersByEmail.length >= 3) {
        this.searchUsersByEmail(this.getUsersByEmail);
      }
    },
    async searchUsersByEmail(val) {
      val = (val || '').toLowerCase();
      this.emailSearching = true;
      var tempList = [];

      // Use GSI query for exact email match - instant lookup
      const exactMatch = await API.graphql({
        query: haikuboxUserByEmail,
        variables: {
          email: val,
        },
      });
      var exactUsers = exactMatch.data.haikuboxUserByEmail.items;
      if (exactUsers.length > 0) {
        for (var i = 0; i < exactUsers.length; i++) {
          tempList.push(exactUsers[i].email);
        }
        this.usersList = tempList;
        this.emailSearching = false;
        return;
      }

      // Fall back to contains search if no exact match
      var nextToken = null;
      do {
        const filteredUsers = await API.graphql({
          query: listHaikuboxUsers,
          variables: {
            nextToken: nextToken,
            filter: { email: { contains: val } },
          },
        });
        var usersList = filteredUsers.data.listHaikuboxUsers.items;
        nextToken = filteredUsers.data.listHaikuboxUsers.nextToken;

        for (var j = 0; j < usersList.length; j++) {
          tempList.push(usersList[j].email);
        }
        if (tempList.length > 20) break;
      } while (nextToken != null);
      this.usersList = tempList;
      this.emailSearching = false;
    },
    getImageUrl(spCode) {
      var imageUrl =
        "https://haikubox-images.s3.amazonaws.com/" + spCode + ".jpeg";
      return imageUrl;
    },
    isBat(itemOrSpCode) {
      if (typeof itemOrSpCode === 'object' && itemOrSpCode !== null) {
        return itemOrSpCode.group === 'bat';
      }
      return itemOrSpCode === 'batbatbat';
    },
    navigateTo(url) {
      console.log('navigatTo', url);
      window.open(url, '_blank');
    },
    replaceSpaces(itemWithSpaces) {
      const itemWithUnderscores = itemWithSpaces.replace(/ /g, "_");
      const itemWithApostrophe = itemWithUnderscores.replace(/'/g, "");
      const itemWithColon = itemWithApostrophe.replace(/:/g, "");
      const itemWithComma = itemWithColon.replace(/,/g, "");
      // console.log("link", itemWithColon);
      return itemWithComma;
    },
    labelText(commonName) {
      return "Is" + " " + commonName + " " + "Correct" + "?";
    },
    extractOffsetFromWav(wavFile, detectionTime, hitItem) {
      // createdAt = recording start time (written by lambda)
      // dt = detection time
      // offset = dt - createdAt
      const filename = wavFile.split("/").pop();
      const match = filename.match(/_(\d+)\.flac$/);

      if (match && hitItem && hitItem.createdAt && hitItem.dt) {
        const fileStartUnix = Math.floor(
          new Date(hitItem.createdAt).getTime() / 1000
        );
        const detectionUnix = Math.floor(new Date(hitItem.dt).getTime() / 1000);
        const offset = detectionUnix - fileStartUnix;

        if (offset >= 0) {
          return offset;
        }
        return null;
      }

      return null;
    },
    async download(item) {
      // console.log(item);
      let audioFile = item.currentWav["filename"];

      this.initAudioContext();

      if (globalAudioContext.state === "suspended") {
        globalAudioContext.resume();
      }

      globalGainNode.gain.value = this.playbackGain;
      if (audioFile[5] == "P" | audioFile[0] == "p") {
          globalGainNode.gain.value = globalGainNode.gain.value / 20;
      }

      // Get audio URL based on file prefix
      var audioUrl;
      if (audioFile[0] == "b") {
        audioUrl = await this.getAudioUrl(audioFile);
      } else {
        audioUrl = await Storage.get(audioFile);
      }

      const response = await fetch(audioUrl);
      const arrayBuffer = await response.arrayBuffer();

      // Detect the native sample rate to preserve it
      let detectedSampleRate = await this.detectFlacSampleRate(arrayBuffer);
      if (!detectedSampleRate) {
        detectedSampleRate = await this.getAudioSampleRate(arrayBuffer);
      }

      // Get or create matching audio context to preserve sample rate
      const audioContext = await this.getMatchingAudioContext(
        detectedSampleRate || 44100
      );

      // Decode audio with the matching context
      const audioBuffer = await this.decodeAudioData(
        audioContext,
        arrayBuffer.slice(0)
      );
      let signal = audioBuffer.getChannelData(0);
      // Remove DC offset before scaling
      const dcOffset = signal.reduce((sum, val) => sum + val, 0) / signal.length;
      const dcRemoved = signal.map((value) => value - dcOffset);
      const peak = dcRemoved.reduce((acc, val) => Math.max(acc, Math.abs(val)), 0);
      const normalizedSignal = peak > 0 ? dcRemoved.map((value) => 0.8 * value / peak) : dcRemoved;
      // console.log(audioBuffer);

      function saveArrayToWavFile(array, sampleRate, filename) {
        const numChannels = 1;
        const bitsPerSample = 16;
        const byteRate = (sampleRate * numChannels * bitsPerSample) / 8;
        const blockAlign = (numChannels * bitsPerSample) / 8;
        const dataSize = (array.length * bitsPerSample) / 8;
        const fileLength = 44 + dataSize;

        // Create a buffer for the WAV file
        const buffer = new ArrayBuffer(fileLength);
        const view = new DataView(buffer);

        // Write the WAV file header
        writeString(view, 0, "RIFF");
        view.setUint32(4, fileLength - 8, true);
        writeString(view, 8, "WAVE");
        writeString(view, 12, "fmt ");
        view.setUint32(16, 16, true);
        view.setUint16(20, 1, true);
        view.setUint16(22, numChannels, true);
        view.setUint32(24, sampleRate, true);
        view.setUint32(28, byteRate, true);
        view.setUint16(32, blockAlign, true);
        view.setUint16(34, bitsPerSample, true);
        writeString(view, 36, "data");
        view.setUint32(40, dataSize, true);

        // Write the sample data
        for (let i = 0; i < array.length; i++) {
          view.setInt16(44 + i * 2, array[i] * 32767, true);
        }

        // Convert the buffer to a Blob
        const blob = new Blob([buffer], { type: "audio/wav" });

        // Create a link element and trigger a wav download
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }

      function writeString(view, offset, string) {
        for (let i = 0; i < string.length; i++) {
          view.setUint8(offset + i, string.charCodeAt(i));
        }
      }
      let filename =
        this.replaceSpaces(item.cn) +
        "_" +
        this.replaceSpaces(item.currentWav["listname"]) +
        ".wav";
      saveArrayToWavFile(normalizedSignal, audioBuffer.sampleRate, filename);
    },
    normalizeAudioBuffer(audioBuffer, targetPeak = 0.95, fadeOutDuration = 0.01) {
      const normalizedBuffer = globalAudioContext.createBuffer(
        audioBuffer.numberOfChannels,
        audioBuffer.length,
        audioBuffer.sampleRate
      );
      
      // Find peak amplitude
      let maxAmplitude = 0;
      for (let channel = 0; channel < audioBuffer.numberOfChannels; channel++) {
        const channelData = audioBuffer.getChannelData(channel);
        for (let i = 0; i < channelData.length; i++) {
          const amplitude = Math.abs(channelData[i]);
          if (amplitude > maxAmplitude) {
            maxAmplitude = amplitude;
          }
        }
      }
      
      const scaleFactor = maxAmplitude > 0 ? targetPeak / maxAmplitude : 1;
      
      // Calculate fade out samples
      const fadeOutSamples = Math.floor(fadeOutDuration * audioBuffer.sampleRate);
      const startFade = audioBuffer.length - fadeOutSamples;
      
      // Apply normalization and fade out
      for (let channel = 0; channel < audioBuffer.numberOfChannels; channel++) {
        const channelData = audioBuffer.getChannelData(channel);
        const normalizedData = normalizedBuffer.getChannelData(channel);
        
        for (let i = 0; i < channelData.length; i++) {
          let sample = channelData[i] * scaleFactor;
          
          // Apply fade out
          if (i >= startFade) {
            const fadePosition = (i - startFade) / fadeOutSamples;
            const fadeGain = 1 - fadePosition; // Linear fade
            // Or use cosine fade for smoother result:
            // const fadeGain = Math.cos(fadePosition * Math.PI / 2);
            sample *= fadeGain;
          }
          
          normalizedData[i] = sample;
        }
      }
      
      return normalizedBuffer;
    },
    initAudioContext() {
      if (globalAudioContext == null) {
        const isIOS = /iPhone|iPod|iPad/.test(navigator.userAgent);
        if (isIOS) {
          globalAudioContext = new AudioContext();
          // Note: audioContext, allowBackgroundPlayback, forceIOSBehavior
          unmute(globalAudioContext, false, false);
        } else {
          globalAudioContext = new AudioContext();
        }
        globalGainNode = globalAudioContext.createGain();
        globalGainNode.gain.value = this.playbackGain; // Set initial volume level
        globalGainNode.connect(globalAudioContext.destination);
      }
    },
    async playFile(audioFile, spCode, cn, item, index, resetLabel) {
      // console.log(item);
      // console.log("playFile", resetLabel);
      // reset label is true when playing from wav select dropdown

      if (resetLabel === true) {
        item.classLabel = null;
        // get favorite status for this file

        const favoriteHit = await API.graphql({
          query: getFavoriteHit,
          variables: {
            id: audioFile,
          },
        });

        if (favoriteHit.data.getFavoriteHit != null) {
          item.favoriteHit = true;
        } else {
          item.favoriteHit = false;
        }
        item.wav = audioFile;
      }
      console.log("playFile", audioFile);

      this.initAudioContext();

      if (globalAudioContext.state === "suspended") {
        globalAudioContext.resume();
      }

      globalGainNode.gain.value = this.playbackGain;

      var audioUrl;
      if(audioFile[0]=='b') {
        audioUrl = await this.getAudioUrl(audioFile);
      }
      else{
        audioUrl = await Storage.get(audioFile);
      }
      
      const response = await fetch(audioUrl);
      const arrayBuffer = await response.arrayBuffer();
      const audioBuffer = await globalAudioContext.decodeAudioData(arrayBuffer);

      console.log(audioBuffer);
      console.log('AudioContext state:', globalAudioContext.state);
      console.log('AudioContext time:', globalAudioContext.currentTime);

      // Store audio duration on the item for UI controls
      if (item && !item.audioDuration) {
        item.audioDuration = audioBuffer.duration;

        // Update maxClipSeconds if we found a long file
        const hasLongFile = this.hits.some(hit => hit.audioDuration && hit.audioDuration > 3);
        if (hasLongFile && this.maxClipSeconds <= 3) {
          this.maxClipSeconds = 12;
          console.log('Detected loaded file > 3s in playFile, setting maxClipSeconds to 12');
        }
      }

      // Calculate start time and duration for long files
      let startTime = 0;
      let playbackDuration = audioBuffer.duration;

      if (audioBuffer.duration > 3) {
        playbackDuration = this.clipSeconds;
        let offset = null;

        // Priority 1: stored offset from extractOffsetFromWav (uses createdAt)
        if (item.currentWav && typeof item.currentWav.offset === 'number') {
          offset = item.currentWav.offset;
        }

        // Priority 2: filename_unix − duration (proxy, ~1s off)
        if (offset === null && item.dt) {
          const filename = audioFile.split("/").pop();
          const match = filename.match(/_(\d+)\.flac$/);
          if (match) {
            const fileEndTimestamp = parseInt(match[1]);
            const fileStartTimestamp = fileEndTimestamp - audioBuffer.duration;
            const detectionUnix = Math.floor(Date.parse(item.dt) / 1000);
            const filenameOffset = detectionUnix - fileStartTimestamp;
            if (filenameOffset >= 0 && filenameOffset <= audioBuffer.duration) {
              offset = filenameOffset;
            }
          }
        }



        if (offset !== null) {
          startTime = offset - this.clipSeconds / 2;
        }

        // Ensure startTime is within bounds
        if (startTime < 0) startTime = 0;
        if (startTime + this.clipSeconds > audioBuffer.duration) {
          startTime = audioBuffer.duration - this.clipSeconds;
        }
        if (startTime < 0) startTime = 0;
      }

      const normalizedBuffer = this.normalizeAudioBuffer(audioBuffer, 0.50);

      const sampleSource = globalAudioContext.createBufferSource();
      sampleSource.buffer = normalizedBuffer;
      sampleSource.connect(globalGainNode);


      sampleSource.onended = () => {
        console.log('Playback completed at:', globalAudioContext.currentTime);
      };
      sampleSource.start(0, startTime, playbackDuration);
    

      // if (this.currentView == "Recent") {
      //   if (item.window == "spectrogram") {
      //     this.spectrogram(index, item.currentWav["filename"], "Recent");
      //     item.classLabel = null;
      //   }
      // }
    },
    generateHannWindow(length) {
      const window = new Float32Array(length);
      for (let i = 0; i < length; i++) {
        window[i] = 0.5 * (1 - Math.cos((2 * Math.PI * i) / (length - 1)));
      }
      return window;
    },

    applyCos2Ramp(signal, sampleRate, rampDurationMs = 5) {
      // Calculate ramp length in samples (default 5ms)
      const rampLength = Math.floor((rampDurationMs / 1000) * sampleRate);
      const effectiveRampLength = Math.min(rampLength, Math.floor(signal.length / 2));

      // Apply fade-in (cos² ramp at the beginning)
      for (let i = 0; i < effectiveRampLength; i++) {
        const angle = (Math.PI / 2) * (i / effectiveRampLength);
        const ramp = Math.sin(angle) * Math.sin(angle);
        signal[i] *= ramp;
      }

      // Apply fade-out (cos² ramp at the end)
      for (let i = 0; i < effectiveRampLength; i++) {
        const idx = signal.length - 1 - i;
        const angle = (Math.PI / 2) * (i / effectiveRampLength);
        const ramp = Math.sin(angle) * Math.sin(angle);
        signal[idx] *= ramp;
      }

      return signal;
    },

    getOptimalFFTLength(sampleRate) {
      const fftLengthMap = {
        8000: 256,
        16000: 512,
        22050: 512,
        24000: 512,
        32000: 1024,
        44100: 1024,
        48000: 1024,
        96000: 2048,
        176400: 4096,
        192000: 4096,
      };

      // Find closest sample rate in map
      const rates = Object.keys(fftLengthMap)
        .map(Number)
        .sort((a, b) => a - b);
      let closestRate = rates[0];

      for (const rate of rates) {
        if (Math.abs(sampleRate - rate) < Math.abs(sampleRate - closestRate)) {
          closestRate = rate;
        }
      }

      return fftLengthMap[closestRate] || 512;
    },

    // Helper method to decode audio data with promise wrapper
    decodeAudioData(audioContext, arrayBuffer) {
      return new Promise((resolve, reject) => {
        audioContext.decodeAudioData(
          arrayBuffer,
          (decodedData) => resolve(decodedData),
          (error) => reject(error)
        );
      });
    },

    async playFileEnhance(audioFile, spCode, cn, id) {

      this.initAudioContext();
      if (globalAudioContext.state === "suspended") {
        globalAudioContext.resume();
      }

      // playing last file again
      if (this.lastEnhancedId == id) {
        // Create an AudioBufferSourceNode
        const sourceNode = globalAudioContext.createBufferSource();
        sourceNode.buffer = this.lastEnhancedAudio;
        // Connect the source node to the AudioContext's destination (speakers)
        sourceNode.connect(globalAudioContext.destination);
        // Start playback
        sourceNode.start();
        return;
      }

      try {
        // Find the item in hits array
        const item = this.hits.find(hit => hit.id === id);

        // Get audio URL based on file prefix
        var audioUrl;
        if (audioFile[0] == "b") {
          audioUrl = await this.getAudioUrl(audioFile);
        } else {
          audioUrl = await Storage.get(audioFile);
        }

        // Fetch and decode with proper sample rate handling
        const response = await fetch(audioUrl);
        const arrayBuffer = await response.arrayBuffer();

        // Detect the native sample rate
        let detectedSampleRate = await this.detectFlacSampleRate(arrayBuffer);
        if (!detectedSampleRate) {
          detectedSampleRate = await this.getAudioSampleRate(arrayBuffer);
        }

        // Get or create matching audio context
        const audioContext = await this.getMatchingAudioContext(
          detectedSampleRate || 44100
        );
        const sample = await decodeAudioData(
          audioContext,
          arrayBuffer.slice(0)
        );

        // Store audio duration on the item for UI controls
        if (item && !item.audioDuration) {
          item.audioDuration = sample.duration;

          // Update maxClipSeconds if we found a long file
          const hasLongFile = this.hits.some(hit => hit.audioDuration && hit.audioDuration > 3);
          if (hasLongFile && this.maxClipSeconds <= 3) {
            this.maxClipSeconds = 12;
            console.log('Detected loaded file > 3s in playFileEnhance, setting maxClipSeconds to 12');
          }
        }

        let origSignal = sample.getChannelData(0);
        var signal;
        let startTime = 0;

        // Define the start and end times (in seconds) - same logic as playFile
        if (
          (audioFile[5] == "P") | (audioFile[0] == "p") ||
          sample.duration > 3
        ) {
          // Priority 1: stored offset (uses createdAt)
          if (item && item.currentWav && typeof item.currentWav.offset === 'number') {
            startTime = item.currentWav.offset - this.clipSeconds / 2;
          } else if (item && item.dt) {
            // Priority 2: filename_unix − duration
            const filename = audioFile.split("/").pop();
            const match = filename.match(/_(\d+)\.flac$/);
            if (match) {
              const fileEndTimestamp = parseInt(match[1]);
              const fileStartTimestamp = fileEndTimestamp - sample.duration;
              const detectionUnix = Math.floor(Date.parse(item.dt) / 1000);
              const offset = detectionUnix - fileStartTimestamp;
              if (offset >= 0 && offset <= sample.duration) {
                startTime = offset - this.clipSeconds / 2;
              }
            }
          }

          // Ensure startTime is within bounds
          if (startTime < 0) startTime = 0;
          if (startTime + this.clipSeconds > sample.duration) {
            startTime = sample.duration - this.clipSeconds;
          }
          if (startTime < 0) startTime = 0;

          // Convert time to sample indices
          var startSample = Math.floor(startTime * sample.sampleRate);
          var endSample = Math.floor(
            (startTime + this.clipSeconds) * sample.sampleRate
          );

          // Check if playback beyond end of clip
          if (endSample > sample.length) {
            endSample = sample.length - 1;
            startSample = endSample - this.clipSeconds * sample.sampleRate;
            if (startSample < 0) startSample = 0;
          }

          signal = origSignal.slice(startSample, endSample);
        } else {
          signal = origSignal;
        }

        // Define STFT parameters (enhancement code)
        const fftSize = 512;
        const overlap = 256;
        const hopSize = fftSize - overlap;

        // Compute the STFT
        const stft = [];
        var meanMag = new Array(fftSize).fill(0);
        var stdMag = new Array(fftSize).fill(0);
        var numStrides = 0;

        // Generate Hann window
        const hann = this.generateHannWindow(fftSize);

        for (let i = 0; i < signal.length - fftSize; i += hopSize) {
          const frame = signal.slice(i, i + fftSize);
          // Hanning Window
          for (var k = 0; k < fftSize; k++) {
            frame[k] = frame[k] * hann[k];
          }
            var phasors = fft(frame);
            // console.log(phasors);
            // store running sum of magnitude to calculate mean
            for (var j = 0; j < phasors.length; j++) {
              meanMag[j] += Math.sqrt(
                phasors[j][0] * phasors[j][0] + phasors[j][1] * phasors[j][1]
              );
            }
            numStrides++;
            stft.push([...phasors]);
          }
          // console.log('stft', stft);
          for (let j = 0; j < fftSize; j++) {
            meanMag[j] = meanMag[j] / numStrides;
          }
          // calculate SD
          // loop through each time slice
          for (let i = 0; i < stft.length; i++) {
            // loop through each frequency
            for (let j = 0; j < fftSize; j++) {
              let magnitude =
                Math.sqrt(
                  stft[i][j][0] * stft[i][j][0] + stft[i][j][1] * stft[i][j][1]
                ) - meanMag[j];
              stdMag[j] += magnitude * magnitude;
            }
          }
          for (j = 0; j < fftSize; j++) {
            stdMag[j] = Math.sqrt(stdMag[j] / numStrides);
          }
          // gate values based on mean + 2*SD
          const gateSpectrogram = async () => {
            for (let i = 0; i < stft.length - 4; i++) {
              // loop through each frequency
              for (let j = 0; j < fftSize; j++) {
                // get average magnitude over 5 time slices
                let magnitude =
                  (Math.sqrt(
                    stft[i][j][0] * stft[i][j][0] +
                      stft[i][j][1] * stft[i][j][1]
                  ) +
                    Math.sqrt(
                      stft[i + 1][j][0] * stft[i + 1][j][0] +
                        stft[i + 1][j][1] * stft[i + 1][j][1]
                    ) +
                    Math.sqrt(
                      stft[i + 2][j][0] * stft[i + 2][j][0] +
                        stft[i + 2][j][1] * stft[i + 2][j][1]
                    ) +
                    Math.sqrt(
                      stft[i + 3][j][0] * stft[i + 3][j][0] +
                        stft[i + 3][j][1] * stft[i + 3][j][1]
                    ) +
                    Math.sqrt(
                      stft[i + 4][j][0] * stft[i + 4][j][0] +
                        stft[i + 4][j][1] * stft[i + 4][j][1]
                    )) /
                  5;
                if (magnitude < meanMag[j] + 1.9 * stdMag[j]) {
                  stft[i][j][0] = stft[i][j][0] * 0.2;
                  stft[i][j][1] = stft[i][j][1] * 0.2;
                  // also flip mirror
                  stft[i][fftSize - 1 - j][0] =
                    stft[i][fftSize - 1 - j][0] * 0.2;
                  stft[i][fftSize - 1 - j][1] =
                    stft[i][fftSize - 1 - j][1] * 0.2;
                  // console.log(i, j);
                }
                if (j < 4) {
                  stft[i][j][0] = stft[i][j][0] * 0.2;
                  stft[i][j][1] = stft[i][j][1] * 0.2;
                  // also flip mirror
                  stft[i][fftSize - 1 - j][0] =
                    stft[i][fftSize - 1 - j][0] * 0.2;
                  stft[i][fftSize - 1 - j][1] =
                    stft[i][fftSize - 1 - j][1] * 0.2;
                  // console.log(i, j);
                }
              }
            }
            return stft;
          };
          // Compute the ISTFT
          const istft = async () => {
            let recoveredSignal = new Array(signal.length).fill(0);
            let recoveredSignalComplex = new Array(fftSize);
            for (let i = 0; i < stft.length - 4; i++) {
              // console.log('before ifft', stft[i]);
              recoveredSignalComplex = ifft(stft[i]);
              // console.log('recoveredSignalComplex', recoveredSignalComplex);
              for (let j = 0; j < fftSize; j++) {
                if (i * overlap + j < signal.length) {
                  // get real part
                  recoveredSignal[i * hopSize + j] +=
                    recoveredSignalComplex[j][0];
                }
              }
            }
            return recoveredSignal;
          };
          gateSpectrogram()
            .then(() => {
              //console.log(res);
              return istft();
            })
            .then((recoveredSignal) => {
              // console.log('recoveredSignal', recoveredSignal);
              var maxSignal = 0;
              for (let i = 0; i < recoveredSignal.length - 1000; i += 1000) {
                // get stack issues so doing in chunks
                var tempMax = Math.max(...recoveredSignal.slice(i, i + 1000));
                if (tempMax > maxSignal) {
                  maxSignal = tempMax;
                }
              }
              maxSignal = 0.9 / maxSignal;

              // Normalize the signal
              for (let i = 0; i < recoveredSignal.length; i++) {
                recoveredSignal[i] = recoveredSignal[i] * maxSignal;
              }

              // Apply cos² ramp to prevent clicks at start/end
              this.applyCos2Ramp(recoveredSignal, sample.sampleRate, 5);

              // Check if this is a 192 kHz file that needs pitch shifting
              const is192k = detectedSampleRate >= 176400; // 176.4 kHz or 192 kHz
              let outputSampleRate = sample.sampleRate;

              if (is192k) {
                // For 192 kHz files, pitch shift down by factor of 5
                // This makes 96 kHz content sound like 19.2 kHz (96000 / 5 = 19200)
                outputSampleRate = Math.round(sample.sampleRate / 5);
                console.log(`Pitch shifting: ${sample.sampleRate}Hz -> ${outputSampleRate}Hz (5x down)`);
              }

              // Create an AudioBuffer from the audio data
              const audioBuffer = audioContext.createBuffer(
                1,
                recoveredSignal.length,
                outputSampleRate
              );
              const channelData = audioBuffer.getChannelData(0);
              for (let i = 0; i < recoveredSignal.length; i++) {
                channelData[i] = recoveredSignal[i];
              }

              // Create an AudioBufferSourceNode
              const sourceNode = audioContext.createBufferSource();
              sourceNode.buffer = audioBuffer;
              // Connect the source node to the AudioContext's destination (speakers)
              sourceNode.connect(audioContext.destination);
              // Start playback
              sourceNode.start();
              this.lastEnhancedId = id;
              this.lastEnhancedAudio = audioBuffer;
            });
      } catch (error) {
        console.error('Error in playFileEnhance:', error);
      }
    },
    async spectrogram(index, audioFile, pageType) {
      this.initAudioContext();

      try {
        // Get the item based on pageType
        let item;
        if (pageType === "Recent") {
          item = this.hits[index];
        } else if (pageType === "All") {
          item = this.seriesDaily[index];
        } else if (pageType === "New") {
          item = this.newSpeciesList[index];
        } else if (pageType === "Missing") {
          item = this.missingSpeciesList[index];
        }

        // Get audio URL based on file prefix
        let audioUrl;
        if (audioFile[0] === 'b') {
          audioUrl = await this.getAudioUrl(audioFile);
        } else {
          audioUrl = await Storage.get(audioFile);
        }

        // Fetch and detect sample rate
        const response = await fetch(audioUrl);
        const arrayBuffer = await response.arrayBuffer();

        let detectedSampleRate = await this.detectFlacSampleRate(arrayBuffer);
        if (!detectedSampleRate) {
          detectedSampleRate = await this.getAudioSampleRate(arrayBuffer);
        }

        // Get or create matching audio context
        const audioContext = await this.getMatchingAudioContext(
          detectedSampleRate || 44100
        );
        const audioBuffer = await this.decodeAudioData(
          audioContext,
          arrayBuffer.slice(0)
        );

        // Extract signal with proper clip windowing
        let origSignal = audioBuffer.getChannelData(0);
        let signal;
        const actualSampleRate = audioBuffer.sampleRate;

        // Define the start and end times
        let startTime = 0;
        let endTime = Math.min(this.clipSeconds, audioBuffer.duration);

        // Handle clip windowing for long files
        if (audioBuffer.duration > 3) {
          let offset = null;
  
          // Priority 1: stored offset (uses createdAt)
          if (item && item.currentWav && typeof item.currentWav.offset === 'number') {
            offset = item.currentWav.offset;
            }

          // Priority 2: filename_unix − duration
          if (offset === null && item && item.dt) {
            const filename = audioFile.split("/").pop();
            const match = filename.match(/_(\d+)\.flac$/);
            if (match) {
              const fileEndTimestamp = parseInt(match[1]);
              const fileStartTimestamp = fileEndTimestamp - audioBuffer.duration;
              const detectionUnix = Math.floor(Date.parse(item.dt) / 1000);
              const filenameOffset = detectionUnix - fileStartTimestamp;
              if (filenameOffset >= 0 && filenameOffset <= audioBuffer.duration) {
                offset = filenameOffset;
                }
            }
          }



          if (offset !== null) {
            startTime = offset - this.clipSeconds / 2;
          }

          // Ensure startTime is within bounds
          if (startTime < 0) startTime = 0;
          if (startTime > audioBuffer.duration - this.clipSeconds) {
            startTime = audioBuffer.duration - this.clipSeconds;
          }
          if (startTime < 0) startTime = 0;

          endTime = startTime + this.clipSeconds;
        }

        // Convert time to sample indices
        const startSample = Math.floor(startTime * actualSampleRate);
        let endSample = Math.floor(endTime * actualSampleRate);

        // Ensure we don't go beyond the audio buffer
        if (endSample > audioBuffer.length) {
          endSample = audioBuffer.length;
        }

        // Extract the signal window
        signal = origSignal.slice(startSample, endSample);

        // Dynamic FFT length based on sample rate
        const fftLength = this.getOptimalFFTLength(actualSampleRate);
        const halfLength = fftLength / 2;

        // Control frequency cutoff - 41.67% to show 10kHz for 24kHz files, 80kHz for 192kHz
        const frequencyRatio = 0.4166666666667;
        const targetMaxFreq = Math.min(96000, actualSampleRate * frequencyRatio);
        const nyquistFreq = actualSampleRate / 2;
        const binFrequency = nyquistFreq / halfLength;
        const targetBins = Math.min(
          Math.floor(targetMaxFreq / binFrequency),
          halfLength
        );
        const showLength = targetBins;

        const overlap = 0.5;
        const hopSize = Math.floor(fftLength * (1.0 - overlap));
        const numTimeSteps = Math.floor((signal.length - fftLength) / hopSize) + 1;
        const fft = new FFT(fftLength, actualSampleRate);

        // Generate Hann window
        const hannWindow = this.generateHannWindow(fftLength);

        // Generate spectrogram - store as 2D array
        const spectrogramData = [];
        const allValues = [];

        // Initialize the 2D array
        for (let i = 0; i < showLength; i++) {
          spectrogramData[i] = [];
        }

        // Process each time window
        for (let timeStep = 0; timeStep < numTimeSteps; timeStep++) {
          const startIdx = timeStep * hopSize;
          const chunk = signal.slice(startIdx, startIdx + fftLength);

          // Pad with zeros if needed
          while (chunk.length < fftLength) {
            chunk.push(0);
          }

          // Apply Hann window
          for (let i = 0; i < fftLength; i++) {
            chunk[i] = chunk[i] * hannWindow[i];
          }

          // Perform FFT
          fft.forward(chunk);

          const scaleFactor = fftLength / 2;

          // Convert to dB and store
          for (let freqBin = 0; freqBin < showLength; freqBin++) {
            const value = fft.spectrum[freqBin] * scaleFactor;
            const db = 20 * Math.log10(Math.max(value, 1e-10));
            spectrogramData[freqBin][timeStep] = db;
            allValues.push(db);
          }
        }

        // Calculate percentiles for color scaling
        allValues.sort((a, b) => a - b);
        const percentile = (p) => {
          const index = Math.floor((allValues.length * p) / 100);
          return allValues[Math.min(index, allValues.length - 1)];
        };

        const minVal = percentile(30);
        const maxVal = percentile(99);

        // Clamp values
        for (let i = 0; i < showLength; i++) {
          for (let j = 0; j < numTimeSteps; j++) {
            spectrogramData[i][j] = Math.max(
              minVal,
              Math.min(maxVal, spectrogramData[i][j])
            );
          }
        }

        // Gaussian smoothing
        for (let i = 1; i < showLength - 1; i++) {
          for (let j = 1; j < numTimeSteps - 1; j++) {
            spectrogramData[i][j] =
              0.25 * spectrogramData[i][j] +
              0.125 * spectrogramData[i - 1][j] +
              0.125 * spectrogramData[i + 1][j] +
              0.125 * spectrogramData[i][j - 1] +
              0.125 * spectrogramData[i][j + 1] +
              0.0625 * spectrogramData[i - 1][j - 1] +
              0.0625 * spectrogramData[i - 1][j + 1] +
              0.0625 * spectrogramData[i + 1][j - 1] +
              0.0625 * spectrogramData[i + 1][j + 1];
          }
        }

        // Create frequency values for y-axis
        const freqValues = [];
        for (let i = 0; i < showLength; i++) {
          freqValues.push(i * binFrequency);
        }

        // Create time values for x-axis
        const timeValues = [];
        const timePerStep = hopSize / actualSampleRate;
        for (let i = 0; i < numTimeSteps; i++) {
          timeValues.push(startTime + i * timePerStep);
        }

        // Improved colorscale
        const colorscale = [
          [0, "#440154"], // Dark purple
          [0.3, "#3b528b"], // Dark blue
          [0.7, "#21908c"], // Teal
          [0.8, "#5dc863"], // Green
          [0.9, "#fde725"], // Yellow
          [1, "#ffffff"], // White for peaks
        ];

        // Calculate dynamic range for color scaling
        const dynamicRange = maxVal - minVal;

        // Set the spectrogram data based on pageType
        const spectrogramObject = {
          z: spectrogramData,
          x: timeValues,
          y: freqValues,
          type: "heatmap",
          colorscale: colorscale,
          showscale: false,
          zmin: minVal,
          zmax: maxVal,
          zmid: minVal + dynamicRange * 0.9,
          zsmooth: "best",
          connectgaps: false,
          hovertemplate: `Time: %{x:.2f}s<br>Freq: %{y:.0f}Hz<br><extra></extra>`,
        };

        if (pageType === "Recent") {
          this.hits[index].spectrogram = [spectrogramObject];
          this.hits[index].windowStart = startTime;
          this.hits[index].windowEnd = endTime;
          this.setWindowRecent(
            index,
            "spectrogram",
            this.hits[index].spCode,
            this.hits[index].cn
          );
        } else if (pageType === "All") {
          this.seriesDaily[index].spectrogram = [spectrogramObject];
          this.setWindowAll(
            index,
            "spectrogram",
            this.seriesDaily[index].spCode,
            this.seriesDaily[index].cn
          );
        } else if (pageType === "New") {
          this.newSpeciesList[index].spectrogram = [spectrogramObject];
          this.setWindowNew(
            index,
            "spectrogram",
            this.newSpeciesList[index].spCode,
            this.newSpeciesList[index].cn
          );
        } else if (pageType === "Missing") {
          this.missingSpeciesList[index].spectrogram = [spectrogramObject];
          this.setWindowMissing(
            index,
            "spectrogram",
            this.missingSpeciesList[index].spCode,
            this.missingSpeciesList[index].cn
          );
        }

      } catch (err) {
        console.error("Error processing audio:", err);
        console.log("No audio", audioFile);
        this.snackbar = true;
        return false;
      }
    },
    clearSettings() {
      this.haikuboxProps = [];
      this.subscriptionProps = [];
      this.deviceHistory = [];
      this.haikubox = "";
      this.email = "";
      this.confirmedEmail = "";
      this.accountUpdatedAt = "";
      this.numHaikuboxes = 0;
      this.oneSignalConsentGranted = "";
      this.bootTable = [];
      this.firmwareVersion = "";
      this.cpuTempSeries = [];
      this.signalSeries = [];
      this.nDirectSeries = [];
      this.nCloudSeries = [];
      this.freeGbSeries = [];
      this.vSeries = [];
      this.ovfSeries = [];
      this.postTimeSeries = [];
      this.hits = [];
      this.lat = 0;
      this.lon = 0;
    },
    resetAdmin() {
      this.serialInput = "";
      this.emailInput = "";
      this.haikubox = "";
      this.haikuboxList = this.allDevicesList.slice();
      this.gridSpecies = [];
      this.gridWeek = 0;
      this.clearSettings();
    },
    getEBirdWeek() {
      var w = moment().isoWeek();
      return Math.min(48, Math.max(1, Math.floor(48.0 * w / 52.0)));
    },
    async loadGridSpecies() {
      if (this.lat == 0 && this.lon == 0) return;
      this.gridLoading = true;
      const latRound = Math.round(this.lat);
      const lonRound = Math.round(this.lon);
      const gridId = latRound + ".0_" + lonRound + ".0_" + this.gridWeek;
      try {
        const result = await API.graphql({
          query: getGridByLoc,
          variables: { id: gridId },
        });
        const data = result.data.getGridByLoc;
        if (data && data.spCode) {
          this.gridSpecies = data.spCode.map((code, i) => ({
            spCode: code,
            cn: data.cn && data.cn[i] ? data.cn[i] : '',
          }));
        } else {
          this.gridSpecies = [];
        }
      } catch (err) {
        console.error('loadGridSpecies error:', err);
        this.gridSpecies = [];
      }
      this.gridLoading = false;
    },
    changeGridWeek(delta) {
      this.gridWeek += delta;
      if (this.gridWeek < 1) this.gridWeek = 48;
      if (this.gridWeek > 48) this.gridWeek = 1;
      this.loadGridSpecies();
    },
    onDeviceSearchFocus() {
      if (this.allDevicesList.length === 0 && !this.haikuboxListLoading) {
        this.getHaikuboxList();
      } else if (this.haikuboxList.length === 0 && this.allDevicesList.length > 0) {
        this.haikuboxList = this.allDevicesList.slice();
      }
    },
    onDeviceHistoryExpand() {
      if (!this.deviceHistoryLoaded) {
        this.deviceHistoryLoaded = true;
        this.getDeviceHistory();
      }
    },
    async getHaikuboxList() {
      this.haikuboxListLoading = true;
      this.haikuboxListProgress = 0;
      var nextToken = null;
      var nameList = [];
      var userIds = [];
      const estimatedTotal = 3000; // approximate device count for progress bar

      do {
        const devices = await API.graphql({
          query: haikuboxByType,
          variables: { type: "haikubox", nextToken: nextToken },
        });
        nextToken = devices.data.haikuboxByType.nextToken;
        // Process each page incrementally
        devices.data.haikuboxByType.items.forEach(function (element) {
          if (element.owner != null) {
            if (userIds.includes(element.owner) == false)
              userIds.push(element.owner);
            if (element.name != null)
              nameList.push(element.serial + ": " + element.name);
            else {
              nameList.push(element.serial);
            }
          }
        });
        // Update list and progress as pages arrive
        this.haikuboxList = nameList.slice();
        this.haikuboxListProgress = Math.min(99, Math.round((nameList.length / estimatedTotal) * 100));
      } while (nextToken != null);

      this.haikuboxList = nameList;
      this.allDevicesList = nameList.slice();
      this.userIdList = userIds;
      this.haikuboxListProgress = 100;
      this.haikuboxListLoading = false;
    },
    async getDevicesByOwner() {
      // console.log("getDevicesByOwner", this.email);
      const userInfo = await API.graphql({
        query: haikuboxUserByEmail,
        variables: { email: this.email },
      });
      const userItems = userInfo.data.haikuboxUserByEmail.items;
      this.userNotFound = userItems.length === 0;
      if (this.userNotFound) return;
      this.userID = userItems[0].id;
      // console.log("getDevicesByOwner", userItems[0]);
      this.confirmedEmail = userItems[0].confirmedEmail;
      this.accountUpdatedAt = moment
        .utc(userItems[0].updatedAt)
        .tz("America/New_York")
        .format("dddd, MMMM Do YYYY, h:mm:ss a");

      const devicesByOwner = await API.graphql({
        query: haikuboxByOwner,
        variables: { owner: this.userID },
      });
      var ownerList = devicesByOwner.data.haikuboxByOwner.items;
      //console.log("devicesByOwner", ownerList);
      var nameList = [];
      this.haikuboxProps = ownerList;
      ownerList.forEach(function (element) {
        // console.log(element.owner);
        //if ((element.owner != null) & tempList.includes(element.serial)) {
        if (element.owner != null) {
          if (element.name != null) {
            nameList.push(element.serial + ": " + element.name);
          } else {
            nameList.push(element.serial);
          }
        }
      });
      this.haikuboxList = nameList;
      this.numHaikuboxes = nameList.length;

      // Auto-expand if only one device
      if (this.haikuboxProps.length === 1) {
        this.expandedDevices = [this.haikuboxProps[0]];
      } else {
        this.expandedDevices = [];
      }

      const oneSignalConsent = await API.graphql({
        query: getOneSignalConsent,
        variables: { id: this.userID },
      });
      // console.log("oneSignalConsent", oneSignalConsent);
      try {
        if (
          oneSignalConsent.data.getOneSignalConsent.osConsentGranted == true
        ) {
          this.oneSignalConsentGranted = true;
        } else {
          this.oneSignalConsentGranted = false;
        }
      } catch {
        this.oneSignalConsentGranted = false;
      }
      this.getSubscriptionStatus();
      this.getDeviceStatuses();
    },
    async getDeviceStatuses() {
      const props = this.haikuboxProps;
      const promises = props.map(async (device, idx) => {
        try {
          let haikuboxStatus = [];
          const windows = [
            { amount: 1, unit: 'hours' },
            { amount: 1, unit: 'days' },
            { amount: 30, unit: 'days' },
            { amount: 90, unit: 'days' },
          ];
          for (const window of windows) {
            if (haikuboxStatus.length > 0) break;
            const sinceDate = moment.utc().subtract(window.amount, window.unit).format();
            const result = await API.graphql({
              query: statusByDate,
              variables: {
                serial: device.serial,
                createdAt: { gt: sinceDate },
                sortDirection: 'DESC',
                limit: 20,
              },
            });
            haikuboxStatus = result.data.statusByDate.items;
          }

          if (haikuboxStatus.length > 0) {
            const latest = haikuboxStatus[0];
            const minutesAgo = moment().diff(moment.utc(latest.createdAt), 'minutes');
            let lastReported;
            if (minutesAgo < 60) {
              lastReported = minutesAgo + 'm ago';
            } else if (minutesAgo < 1440) {
              lastReported = Math.floor(minutesAgo / 60) + 'h ago';
            } else {
              lastReported = moment.utc(latest.createdAt).tz(this.timezone || 'America/New_York').format("MM/DD HH:mm");
            }
            let version = '';
            for (let i = 0; i < haikuboxStatus.length; i++) {
              if (haikuboxStatus[i].version) {
                version = haikuboxStatus[i].version;
                break;
              }
            }
            // Check for possible broken microphone:
            // Only for newer devices (12-char uppercase MAC) that report nDirect/nCloud
            // connected reliably (reported within 15m) but zero detections with 0s (not null)
            let diagnosis = '';
            const mac = device.serial.replace('Haikubox_', '');
            if (mac.length === 12 && mac === mac.toUpperCase() && minutesAgo <= 15 && haikuboxStatus.length >= 3) {
              const hasFields = haikuboxStatus.some(s => s.nDirect !== null && s.nDirect !== undefined);
              if (hasFields) {
                const totalDetections = haikuboxStatus.reduce((sum, s) => sum + (s.nDirect || 0) + (s.nCloud || 0), 0);
                if (totalDetections === 0) {
                  diagnosis = 'microphone';
                }
              }
            }

            // Force Vue reactivity by replacing the array item
            this.$set(this.haikuboxProps, idx, {
              ...device,
              statusLastReported: lastReported,
              statusLastReportedMinutes: minutesAgo,
              statusWifiSignal: minutesAgo > 60 ? 'disconnected' : latest.signal,
              statusVersion: version,
              statusDiagnosis: diagnosis,
            });
          }
        } catch (err) {
          // status fetch failed for this device
        }
      });
      await Promise.all(promises);
    },
    async getSubscriptionStatus() {
      // query subscription state
      var subscriptionStates = [];
      for (const item of this.haikuboxProps) {
        // console.log(item);
        const subscriptionStatus = await API.graphql({
          query: getSubscription,
          variables: { id: item.serial },
        });
        // console.log(subscriptionStatus.data.getSubscription);
        if (
          subscriptionStatus.data.getSubscription.prepaidPeriodEndUnix != null
        ) {
          subscriptionStatus.data.getSubscription.prepaidPeriodEndUnix = moment
            .unix(subscriptionStatus.data.getSubscription.prepaidPeriodEndUnix)
            .format("YYYY-MM-DD HH:mm:ss");
        }
        if (
          subscriptionStatus.data.getSubscription.stripeCurrentPeriodEndUnix !=
          null
        ) {
          subscriptionStatus.data.getSubscription.stripeCurrentPeriodEndUnix =
            moment
              .unix(
                subscriptionStatus.data.getSubscription
                  .stripeCurrentPeriodEndUnix
              )
              .format("YYYY-MM-DD HH:mm:ss");
        }
        if (subscriptionStatus.data.getSubscription.applePeriodEndUnix != null) {
          subscriptionStatus.data.getSubscription.applePeriodEndUnix = moment
            .unix(subscriptionStatus.data.getSubscription.applePeriodEndUnix)
            .format("YYYY-MM-DD HH:mm:ss");
        }
        subscriptionStatus.data.getSubscription.name = item.name || '';
        subscriptionStates.push(subscriptionStatus.data.getSubscription);
      }
      this.subscriptionProps = subscriptionStates;
    },
    async selectHaikubox(serialName) {
      // Extract MAC from various input formats:
      // "Haikubox_MAC: Name" (from dropdown), "Haikubox_MAC", or just "MAC"
      let input = serialName.split(":")[0].trim();
      let mac;
      if (input.includes("_")) {
        mac = input.split("_")[1];
      } else {
        mac = input; // User typed just the MAC address
      }

      // Direct lookup by MAC (device table id)
      const deviceInfo = await API.graphql({
        query: getDevice,
        variables: { id: mac },
      });

      if (!deviceInfo.data.getDevice) {
        console.error("Device not found:", mac);
        return;
      }

      const device = deviceInfo.data.getDevice;
      let serialClicked = device.serial; // Use serial from device table

      // get email associated with Haikubox
      const userInfo = await API.graphql({
        query: getHaikuboxUser,
        variables: {
          id: device.owner,
        },
      });
      this.email = userInfo.data.getHaikuboxUser.email;

      // Get lat/lon and timezone from device table
      if (device.lat != null) {
        this.lat = device.lat;
        this.lon = device.lon;
      }
      // Get timezone from lat/lon using tz-lookup
      if (device.lat != null && device.lon != null) {
        try {
          this.timezone = tzlookup(device.lat, device.lon);
        } catch (e) {
          this.timezone = "America/New_York";
        }
      } else {
        this.timezone = "America/New_York";
      }

      this.getDeviceStateInfo(serialClicked);
      this.getBootTable(serialClicked);
      this.getStatus(serialClicked);
      this.getDevicesByOwner(); // load all Haikuboxes for this owner which also gets other info about the Haikubox
      this.getHits(serialClicked);

      // Load eBird grid species for current week
      this.gridWeek = this.getEBirdWeek();
      this.loadGridSpecies();
    },
    async getHits(serialClicked) {
      // console.log("getHits", serialClicked);
      this.currentSerial = serialClicked;
      var nextToken = null;
      let yesterdayDate;
      var tempHits = [];

      if (this.recentHours > 0) {
        yesterdayDate = moment
          .utc()
          .subtract(this.recentHours, "hours")
          .format();
        // console.log(yesterdayDate)
        do {
          const queryHits = await API.graphql({
            query: hitBySerialByDate,
            variables: {
              serial: serialClicked,
              dt: { gt: yesterdayDate },
              sortDirection: "DESC",
              nextToken: nextToken,
            },
            filter: { wav: { gt: "" } },
          });
          tempHits = tempHits.concat(queryHits.data.hitBySerialByDate.items);
          nextToken = queryHits.data.hitBySerialByDate.nextToken;
          this.hitsLoading = tempHits.length;
        } while (nextToken != null);
      }
      if (this.recentHours == 0) {
        let startDate = moment(this.hitDatePicker)
          .tz(this.currentTimezone)
          .utc()
          .format("YYYY-MM-DDTHH:mm:ss");
        let endDate = moment(startDate)
          .add(24, "hours")
          .format("YYYY-MM-DDTHH:mm:ss");
        // console.log('query hits ', startDate, endDate)
        do {
          const queryHits = await API.graphql({
            query: hitBySerialByDate,
            variables: {
              serial: serialClicked,
              dt: { between: [startDate, endDate] },
              sortDirection: "DESC",
              nextToken: nextToken,
            },
            filter: { wav: { gt: "" } },
          });
          tempHits = tempHits.concat(queryHits.data.hitBySerialByDate.items);
          nextToken = queryHits.data.hitBySerialByDate.nextToken;
          this.hitsLoading = tempHits.length;
        } while (nextToken != null);
      }
      // keep track of species in list and put wav files in list
      var speciesHits = [];
      var uniqueHits = [];
      var speciesDict = {};
      var counter = 0;

      for (var i = 0; i < tempHits.length; i++) {
        // var splitWav = tempHits2[i]["wav"].split("_");
        //var wavTimeStamp = splitWav[3].slice(0, -5);
        var wavTimeStamp = tempHits[i].dt;
        // console.log(wavTimeStamp, this.currentTimezone)
        // let wavTimeMoment = moment(wavTimeStamp).fromNow();
        var wavTimeMoment = moment
          .utc(wavTimeStamp)
          .tz(this.currentTimezone)
          .locale(this.selectedLanguage)
          .format('ll LTS');

        // console.log(splitWav, wavTimeStamp);
        // console.log(wavTimeMoment);

        // use for quick check of low scores
        // var listname = "L " + tempHits2[i].score) + ' ' + wavTimeMoment;
        var listname = "L " + wavTimeMoment;
        if ((tempHits[i].score > 0.4) & (tempHits[i].specSum > 2)) {
          listname = "M " + wavTimeMoment;
        }
        if (tempHits[i].score > 0.9 && tempHits[i].specSum > 6) {
          listname = "H " + wavTimeMoment;
        }

        if (
          tempHits[i].score > 0.4 &&
          tempHits[i].specSum > 3 &&
          tempHits[i].version.slice(-1) == "D"
        ) {
          listname = "M. " + wavTimeMoment;
        }
        if (
          tempHits[i].score > 0.9 &&
          tempHits[i].specSum > 5 &&
          tempHits[i].version.slice(-1) == "D"
        ) {
          listname = "H. " + wavTimeMoment;
        }

        if (!speciesHits.includes(tempHits[i].cn)) {
          speciesHits.push(tempHits[i].cn);
          speciesDict[tempHits[i].cn] = counter;
          uniqueHits.push(tempHits[i]);
          uniqueHits[counter].wavList = [
            {
              filename: tempHits[i]["wav"],
              listname: listname,
              dt: tempHits[i]["dt"],
              score: tempHits[i]["score"],
              specSum: tempHits[i]["specSum"],
              offset: this.extractOffsetFromWav(
                tempHits[i]["wav"],
                tempHits[i]["dt"],
                tempHits[i]
              ),
            },
          ];
          uniqueHits[counter].currentWav = {
            filename: tempHits[i]["wav"],
            listname: listname,
            dt: tempHits[i]["dt"],
            score: tempHits[i]["score"],
            specSum: tempHits[i]["specSum"],
            offset: this.extractOffsetFromWav(
              tempHits[i]["wav"],
              tempHits[i]["dt"],
              tempHits[i]
            ),
          };
          uniqueHits[counter].playbackIndex = 0;
          uniqueHits[counter].window = "image";
          uniqueHits[counter].showBird = true;
          uniqueHits[counter].notifyBird = false;
          counter = counter + 1;
        } else {
          uniqueHits[speciesDict[tempHits[i].cn]]["wavList"].push({
            filename: tempHits[i]["wav"],
            listname: listname,
            dt: tempHits[i]["dt"],
            score: tempHits[i]["score"],
            specSum: tempHits[i]["specSum"],
            offset: this.extractOffsetFromWav(
              tempHits[i]["wav"],
              tempHits[i]["dt"],
              tempHits[i]
            ),
          });
        }
      }
      // console.log('speciesHits', speciesHits);
      // console.log('speciesDict', speciesDict);
      // console.log("uniqueHits", uniqueHits);

      // query hidden list for this Haikubox
      // query hideBirds condition for this Haikubox
      const returnCount = await API.graphql({
        query: hideBirdBySerial,
        variables: {
          serial: serialClicked,
        },
      });
      // console.log('hideBirdBySerial', returnCount.data.hideBirdBySerial.items);
      let hiddenBirdList = returnCount.data.hideBirdBySerial.items;
      let customHiddenList = [];
      for (let i = 0; i < hiddenBirdList.length; i++) {
        customHiddenList.push(hiddenBirdList[i].cn);
      }

      // query notify birds
      nextToken = null;
      let notifyBirdList = [];
      do {
        const notify = await API.graphql({
          query: notifyBirdBySerial,
          variables: {
            serial: serialClicked,
            nextToken: nextToken,
          },
        });
        notifyBirdList = notifyBirdList.concat(
          notify.data.notifyBirdBySerial.items
        );
        nextToken = notify.data.notifyBirdBySerial.nextToken;
      } while (nextToken != null);

      let customNotifyList = [];
      // console.log('notifyBirdList', notifyBirdList);
      for (let i = 0; i < notifyBirdList.length; i++) {
        customNotifyList.push(notifyBirdList[i].cn);
      }

      // update hits with notifyBird
      for (i in uniqueHits) {
        if (customNotifyList.includes(uniqueHits[i].cn)) {
          uniqueHits[i].notifyBird = true;
          // console.log("notify index and species", i, uniqueHits[i]);
        }
      }

      // // query favorites
      // for (i = uniqueHits.length - 1; i >= 0; i--) {
      //   uniqueHits[i].favoriteHit = false;
      //   // console.log(uniqueHits[i].currentWav.filename);
      //   const favoriteHit = await API.graphql({
      //     query: getFavoriteHit,
      //     variables: {
      //       id: uniqueHits[i].wav,
      //     },
      //   });
      //   if (favoriteHit.data.getFavoriteHit != null) {
      //     uniqueHits[i].favoriteHit = true;
      //     // console.log('getHits favorite', favoriteHit);
      //   }
      // }

      this.hits = uniqueHits; // this.hits is what is looped through to show cards
      // console.log("hits", this.hits);
      this.hitsLoading = 0; // hide hits loading counter
    },
    hitSelectDate() {
      // console.log('hitsSelectRange');
      if (this.hitCalendarDatePicked == false) {
        this.hitCalendarDatePicked = true; // hide calendar
      } else {
        this.hitCalendarDatePicked = false; // show calendar
        this.recentHours = 0;
      }
    },
    hitDateClick() {
      console.log('hitDateClick', this.hitDatePicker);
      this.hitCalendarDatePicked = true; // hide calendar
      this.changeRecentHours(0);
    },
    changeRecentHours(numHours) {
      this.hitCalendarDatePicked = true; // hide calendar
      this.recentHours = numHours;
      this.hits = [];
      this.hitsLoading = 0;
      this.getHits(this.currentSerial);
    },
    async getBootTable(serialClicked) {
      let lastMonth = moment.utc().subtract(345, "days").format();
      const filterArg = {
        serial: serialClicked,
        createdAt: { gt: lastMonth },
      };
      const bootTable = await API.graphql({
        query: bootBySerialByDate,
        variables: filterArg,
      });
      var bootData = bootTable.data.bootBySerialByDate.items;
      var tempBootTable = [];
      for (var index in bootData) {
        var datetimeX = moment
          .utc(bootData[index].createdAt)
          .tz(this.timezone)
          .format("dddd, MMMM Do YYYY, h:mm:ss a");
        tempBootTable[index] = bootData[index];
        tempBootTable[index].createdAt = datetimeX; // local time
      }
      this.bootTable = tempBootTable;
      // console.log("getBootTable", bootData);
      // if (bootData.length > 0) {
      //   this.firmwareVersion = bootData[bootData.length - 1].version;
      // } else {
      //   this.firmwareVersion = 0;
      // }
    },
    async getStatus(serialClicked) {
      let yesterdayDate = moment.utc().subtract(2, "days").format();
      var nextToken = null;
      var haikuboxStatus = [];

      do {
        const filterArg = {
          serial: serialClicked,
          createdAt: { gt: yesterdayDate },
          nextToken: nextToken,
        };
        const boxStatus = await API.graphql({
          query: statusByDate,
          variables: filterArg,
        });
        haikuboxStatus = haikuboxStatus.concat(
          boxStatus.data.statusByDate.items
        );
        nextToken = boxStatus.data.statusByDate.nextToken;
      } while (nextToken != null);

      // If no data in last 2 days, search further back to find the last active period
      // then load 7 days of data from that point for the plots
      if (haikuboxStatus.length == 0) {
        // Find the most recent status record by searching wider windows
        let lastRecord = null;
        for (const days of [30, 180]) {
          if (lastRecord) break;
          const sinceDate = moment.utc().subtract(days, "days").format();
          const result = await API.graphql({
            query: statusByDate,
            variables: {
              serial: serialClicked,
              createdAt: { gt: sinceDate },
              sortDirection: 'DESC',
              limit: 1,
            },
          });
          if (result.data.statusByDate.items.length > 0) {
            lastRecord = result.data.statusByDate.items[0];
          }
        }

        // If found, load 7 days of data ending at the last record
        if (lastRecord) {
          const lastRecordTime = moment.utc(lastRecord.createdAt);
          const weekBefore = lastRecordTime.clone().subtract(7, "days").format();
          nextToken = null;

          do {
            const filterArg = {
              serial: serialClicked,
              createdAt: { gt: weekBefore },
              nextToken: nextToken,
            };
            const boxStatus = await API.graphql({
              query: statusByDate,
              variables: filterArg,
            });
            haikuboxStatus = haikuboxStatus.concat(
              boxStatus.data.statusByDate.items
            );
            nextToken = boxStatus.data.statusByDate.nextToken;
          } while (nextToken != null);
        }
      }

      // Sort by createdAt to ensure chronological order for charts
      haikuboxStatus.sort((a, b) => moment(a.createdAt).diff(moment(b.createdAt)));

      var cpuTempSeries = [];
      var cpuFreqSeries = [];
      var ramdiskSeries = [];
      var signalSeries = [];
      var nDirectSeries = [];
      var nCloudSeries = [];
      var freeGbSeries = [];
      var vSeries = [];
      var ovfSeries = [];
      var postTimeSeries = [];


      var currentWiFi = 0;

      for (var entry in haikuboxStatus) {
        // Use Date object for proper time axis formatting
        var datetimeX = moment.utc(haikuboxStatus[entry].createdAt).toDate();
        cpuTempSeries.push([datetimeX, haikuboxStatus[entry].cpuTemp]);
        cpuFreqSeries.push([datetimeX, haikuboxStatus[entry].cpuFreq]);
        ramdiskSeries.push([datetimeX, haikuboxStatus[entry].ramdisk]);
        signalSeries.push([datetimeX, haikuboxStatus[entry].signal]);

        nDirectSeries.push([datetimeX, haikuboxStatus[entry].nDirect]);

        nCloudSeries.push([datetimeX, haikuboxStatus[entry].nCloud]);

        if (haikuboxStatus[entry].freeGB != null && haikuboxStatus[entry].freeGB !== undefined) {
          freeGbSeries.push([datetimeX, haikuboxStatus[entry].freeGB]);
        }
        if (haikuboxStatus[entry].V != null && haikuboxStatus[entry].V !== undefined) {
          vSeries.push([datetimeX, haikuboxStatus[entry].V]);
        }

        if (haikuboxStatus[entry].ovf != null && haikuboxStatus[entry].ovf !== undefined) {
          ovfSeries.push([datetimeX, haikuboxStatus[entry].ovf]);
        }

        if (haikuboxStatus[entry].postTime != null && haikuboxStatus[entry].postTime !== undefined) {
          postTimeSeries.push([datetimeX, haikuboxStatus[entry].postTime]);
        }

        currentWiFi = haikuboxStatus[entry].signal;
      }

      // Get firmware version from most recent status that has it
      for (let i = haikuboxStatus.length - 1; i >= 0; i--) {
        if (haikuboxStatus[i].version) {
          this.firmwareVersion = haikuboxStatus[i].version;
          break;
        }
      }

      this.cpuTempSeries = cpuTempSeries;
      this.cpuFreqSeries = cpuFreqSeries;
      this.ramdiskSeries = ramdiskSeries;
      this.signalSeries = signalSeries;
      this.nDirectSeries = nDirectSeries;
      this.nCloudSeries = nCloudSeries;
      this.freeGbSeries = freeGbSeries;
      this.vSeries = vSeries;
      this.ovfSeries = ovfSeries;
      this.postTimeSeries = postTimeSeries;
      this.currentWiFi = currentWiFi;
    },
    async getNotice() {
      const noticeInfo = await API.graphql({
        query: getNoticeDescription,
        variables: { id: this.noticeId },
      });
      this.noticeDescription = noticeInfo.data.getNoticeDescription;
      // console.log("getNotice", this.noticeDescription);
    },
    async fetchDeviceState(serial) {
      const result = await API.graphql({
        query: getDeviceState,
        variables: { id: serial },
      });
      return result.data.getDeviceState; // null if no record yet
    },
    async getDeviceStateInfo(serialClicked) {
      this.deviceState = null;
      this.deviceStateQueried = false;
      try {
        this.deviceState = await this.fetchDeviceState(serialClicked);
      } catch (error) {
        console.error("Error fetching deviceState:", error);
      } finally {
        this.deviceStateQueried = true;
      }
    },
    async loadExpandedDeviceState(serial) {
      this.expandedDeviceState = null;
      this.expandedDeviceStateLoading = true;
      try {
        this.expandedDeviceState = await this.fetchDeviceState(serial);
      } catch (error) {
        console.error("Error fetching deviceState:", error);
      } finally {
        this.expandedDeviceStateLoading = false;
      }
    },
    fmtStateDate(ts) {
      return ts ? moment(ts).format("YYYY-MM-DD HH:mm") : "?";
    },
    async getSerialHistory(serial) {
      if (!serial) return;
      this.serialHistoryLoading = true;
      this.serialHistory = [];
      try {
        var nextToken = null;
        var items = [];
        do {
          const result = await API.graphql({
            query: deviceHistoryBySerial,
            variables: {
              serial: serial,
              limit: 200,
              nextToken: nextToken,
            },
          });
          items = items.concat(result.data.deviceHistoryBySerial.items);
          nextToken = result.data.deviceHistoryBySerial.nextToken;
        } while (nextToken != null);
        this.serialHistory = items;
      } catch (error) {
        console.error("Error fetching device history for serial:", error);
      } finally {
        this.serialHistoryLoading = false;
      }
    },
    onDeviceRowExpanded({ item, value }) {
      // Fetch state + history for the device whose row was just expanded
      if (value) {
        this.loadExpandedDeviceState(item.serial);
        this.getSerialHistory(item.serial);
      }
    },
    async getDeviceHistory() {
      this.deviceHistory = [];
      for (var i = 7; i >= 0; i--) {
        let currentDate = moment.utc().subtract(i, "days").format("YYYY-MM-DD");
        // console.log(currentDate);
        const deviceHistory = await API.graphql({
          query: deviceHistoryByDate,
          variables: { createDate: currentDate },
        });
        this.deviceHistory = this.deviceHistory.concat(
          deviceHistory.data.deviceHistoryByDate.items
        );
      }

      // Fetch version information for each unique serial in INSERT actions
      const insertActions = this.deviceHistory.filter(item => item.deviceAction === 'INSERT');
      const uniqueSerials = [...new Set(insertActions.map(item => item.serial))];

      // Create a map to store versions by serial
      const versionMap = {};

      // Query status table for each serial to get the latest version
      for (const serial of uniqueSerials) {
        try {
          const statusResult = await API.graphql({
            query: statusByDate,
            variables: {
              serial: serial,
              sortDirection: 'DESC',
              limit: 20  // Get last 20 status records to find one with version
            }
          });

          const statusItems = statusResult.data.statusByDate.items;
          // Find the most recent status with a version
          for (let i = 0; i < statusItems.length; i++) {
            if (statusItems[i].version) {
              versionMap[serial] = statusItems[i].version;
              break;
            }
          }
        } catch (error) {
          console.error(`Failed to fetch version for ${serial}:`, error);
        }
      }

      // Update device history items with version information
      this.deviceHistory = this.deviceHistory.map(item => ({
        ...item,
        version: versionMap[item.serial] || item.version || '?'
      }));

      // console.log("getDeviceHistory", this.deviceHistory);
    },
    handleHistoryClick(value) {
      // console.log(value);
      this.haikubox = value.serial + ": " + value.name;
      this.selectHaikubox(value.serial);
    },
    refreshDeviceHistory() {
      this.getDeviceHistory();
    },
    async getMapCountsPerSpecies(commonName) {
      let yesterdayDate = moment
        .utc()
        .local()
        .subtract(24, "hours")
        .format("YYYY-MM-DD");
      var tempHits = [];
      var nextToken = null;
      do {
        const queryHits = await API.graphql({
          query: dailyCountSummaryByDateBySpecies,
          variables: {
            cn: { eq: commonName },
            countDate: yesterdayDate,
            nextToken: nextToken,
          },
        });
        tempHits = tempHits.concat(
          queryHits.data.dailyCountSummaryByDateBySpecies.items
        );
        nextToken = queryHits.data.dailyCountSummaryByDateBySpecies.nextToken;
      } while (nextToken != null);
      // console.log("getMapCountsPerSpecies tempHits", tempHits);
      var mapHits = [];
      for (let i = 0; i < tempHits.length; i++) {
        let mapCount = {
          lat: tempHits[i].lat,
          lon: tempHits[i].lon,
          radius: tempHits[i].countsPerDay * 100,
        };
        mapHits.push(mapCount);
      }
      return mapHits;
    },
    float2int(value) {
      return value | 0;
    },
    async setWindowRecent(index, value, spCode, commonName) {

      if (value == "daily") {
        this.hits[index].hourlyCountPlotData = await this.getHourlySpecies(
          commonName
        );
      }
      if (value == "monthly") {
        this.hits[index].dailyCountPlotData =
          await this.getDailySpeciesChartsJS(commonName);
      }
      if (value == "heatmap") {
        this.hits[index].heatmap = await this.getHeatmap(commonName);
      }
      if (value == "map") {
        this.hits[index].map = await this.getMapCountsPerSpecies(commonName);
      }
      this.hits[index].window = value;
      this.$forceUpdate();
      // this.hits[index].id += 1; // increment ID so that component updates
      // console.log("setWindowRecent", commonName, this.hits[index]);
    },
    // fusioncharts format hourly data
    async getHourlySpecies(cn) {
      let hourlyTimeSeries = Array(24).fill(0);
      var nextToken = null;
      this.lastUpdated = moment
        .utc()
        .local()
        .locale(this.selectedLanguage)
        .calendar();
      let yesterdayDate, todayDate;
      var tempHits = [];

      todayDate = moment.utc().format();

      yesterdayDate = moment.utc().subtract(23, "hours").format();
      // console.log(cn, yesterdayDate, todayDate, this.currentSerial)
      do {
        const queryHits = await API.graphql({
          query: hitsBySpeciesByDate,
          variables: {
            serial: this.currentSerial,
            cnDt: {
              between: [
                { cn: cn, dt: yesterdayDate },
                { cn: cn, dt: todayDate },
              ],
            },
            sortDirection: "DESC",
            nextToken: nextToken,
          },
        });
        tempHits = tempHits.concat(queryHits.data.hitsBySpeciesByDate.items);
        nextToken = queryHits.data.hitsBySpeciesByDate.nextToken;
      } while (nextToken != null);

      // console.log(tempHits);
      // loop through all detections and add to correct hour bin
      // localHour will correspond to bin index 23
      tempHits.forEach((hit) => {
        var currentMinutes = moment.utc().minutes();
        // convert to local time to get correct hour bin
        var diffMinutes = moment.utc(hit["dt"]).diff(todayDate, "minutes");
        var diffHours = moment.utc(hit["dt"]).diff(todayDate, "hours");
        if ((diffHours == 0) & (-diffMinutes > currentMinutes)) diffHours = -1; // round current hour
        // console.log('diff from now', currentMinutes, diffMinutes, diffHours);
        var i = 23 + diffHours;
        if (i < 0) i = 0;
        if (i > 23) i = 23;
        hourlyTimeSeries[i] = hourlyTimeSeries[i] + hit["detectionCount"];
      });
      // console.log("UTC", hourlyTimeSeries);

      function getDates(startDate, stopDate) {
        var dateArray = [];
        var currentDate = moment(startDate).utc();
        stopDate = moment(stopDate).utc();
        // console.log("start date", startDate);
        // console.log("stop date", stopDate);
        while (currentDate <= stopDate) {
          var a = moment.utc(currentDate);
          dateArray.push(a.format());
          currentDate = moment(currentDate).add(1, "hours");
        }
        return dateArray;
      }

      let minMomentDate = moment.utc().subtract(23, "hours");
      minMomentDate.minutes(0);
      minMomentDate.seconds(0);
      let minDate = minMomentDate.format();
      let maxDate = minMomentDate.add(23, "hours").format();
      let dateArr = getDates(minDate, maxDate);
      let localDateArr = [];
      for (let utcDate of dateArr) {
        localDateArr.push([
          moment.utc(utcDate).tz(this.currentTimezone).format("hh:mm a"),
        ]);
      }

      this.chartOptionsHourly = {
        xaxis: {
          categories: localDateArr,
        },
      };

      this.chartOptionsSpeciesHourly = {
        xaxis: {
          categories: localDateArr,
        },
      };

      // console.log(localDateArr);
      // console.log(this.chartOptionsHourly);
      // console.log(this.chartOptionsSpeciesHourly);

      var colorMap = [
        "#ffffd9",
        "#edf8b1",
        "#c7e9b4",
        "#7fcdbb",
        "#41b6c4",
        "#1d91c0",
        "#225ea8",
        "#0c2c84",
      ];

      // console.log("speciesID", speciesID);
      var totalDetections = 0;
      var plotData = [];

      var localHour;
      if (this.chartOptionsSpeciesHourly.xaxis.categories[23] == "12:00 am")
        localHour = 0;
      if (this.chartOptionsSpeciesHourly.xaxis.categories[23] == "01:00 am")
        localHour = 1;
      if (this.chartOptionsSpeciesHourly.xaxis.categories[23] == "02:00 am")
        localHour = 2;
      if (this.chartOptionsSpeciesHourly.xaxis.categories[23] == "03:00 am")
        localHour = 3;
      if (this.chartOptionsSpeciesHourly.xaxis.categories[23] == "04:00 am")
        localHour = 4;
      if (this.chartOptionsSpeciesHourly.xaxis.categories[23] == "05:00 am")
        localHour = 5;
      if (this.chartOptionsSpeciesHourly.xaxis.categories[23] == "06:00 am")
        localHour = 6;
      if (this.chartOptionsSpeciesHourly.xaxis.categories[23] == "07:00 am")
        localHour = 7;
      if (this.chartOptionsSpeciesHourly.xaxis.categories[23] == "08:00 am")
        localHour = 8;
      if (this.chartOptionsSpeciesHourly.xaxis.categories[23] == "09:00 am")
        localHour = 9;
      if (this.chartOptionsSpeciesHourly.xaxis.categories[23] == "10:00 am")
        localHour = 10;
      if (this.chartOptionsSpeciesHourly.xaxis.categories[23] == "11:00 am")
        localHour = 11;
      if (this.chartOptionsSpeciesHourly.xaxis.categories[23] == "12:00 pm")
        localHour = 12;
      if (this.chartOptionsSpeciesHourly.xaxis.categories[23] == "01:00 pm")
        localHour = 13;
      if (this.chartOptionsSpeciesHourly.xaxis.categories[23] == "02:00 pm")
        localHour = 14;
      if (this.chartOptionsSpeciesHourly.xaxis.categories[23] == "03:00 pm")
        localHour = 15;
      if (this.chartOptionsSpeciesHourly.xaxis.categories[23] == "04:00 pm")
        localHour = 16;
      if (this.chartOptionsSpeciesHourly.xaxis.categories[23] == "05:00 pm")
        localHour = 17;
      if (this.chartOptionsSpeciesHourly.xaxis.categories[23] == "06:00 pm")
        localHour = 18;
      if (this.chartOptionsSpeciesHourly.xaxis.categories[23] == "07:00 pm")
        localHour = 19;
      if (this.chartOptionsSpeciesHourly.xaxis.categories[23] == "08:00 pm")
        localHour = 20;
      if (this.chartOptionsSpeciesHourly.xaxis.categories[23] == "09:00 pm")
        localHour = 21;
      if (this.chartOptionsSpeciesHourly.xaxis.categories[23] == "10:00 pm")
        localHour = 22;
      if (this.chartOptionsSpeciesHourly.xaxis.categories[23] == "11:00 pm")
        localHour = 23;
      var startingAngle = 260 - localHour * (360 / 24);
      if (startingAngle < 0) startingAngle += 360;
      // console.log('localHour', localHour);
      // console.log("startingAngle", startingAngle);

      for (var i = 23; i > -1; i--) {
        var colorMapIndex = 0;
        if (hourlyTimeSeries[i] > 0) colorMapIndex = 1;
        if (hourlyTimeSeries[i] > 1) colorMapIndex = 2;
        if (hourlyTimeSeries[i] > 2) colorMapIndex = 3;
        if (hourlyTimeSeries[i] > 5) colorMapIndex = 4;
        if (hourlyTimeSeries[i] > 10) colorMapIndex = 5;
        if (hourlyTimeSeries[i] > 15) colorMapIndex = 6;
        if (hourlyTimeSeries[i] > 20) colorMapIndex = 7;
        totalDetections += hourlyTimeSeries[i];
        var dateText = this.chartOptionsSpeciesHourly.xaxis.categories[i];
        var showLabel = 0;
        var isSliced = 0;
        var dateTextDict = {
          "12:00 am": "midnight",
          "01:00 am": "1am",
          "02:00 am": "2am",
          "03:00 am": "3am",
          "04:00 am": "4am",
          "05:00 am": "5am",
          "06:00 am": "6am",
          "07:00 am": "7am",
          "08:00 am": "8am",
          "09:00 am": "9am",
          "10:00 am": "10am",
          "11:00 am": "11am",
          "12:00 pm": "noon",
          "01:00 pm": "1pm",
          "02:00 pm": "2pm",
          "03:00 pm": "3pm",
          "04:00 pm": "4pm",
          "05:00 pm": "5pm",
          "06:00 pm": "6pm",
          "07:00 pm": "7pm",
          "08:00 pm": "8pm",
          "09:00 pm": "9pm",
          "10:00 pm": "10pm",
          "11:00 pm": "11pm",
        };
        if (dateText == "12:00 am") showLabel = 1;
        if (dateText == "12:00 pm") showLabel = 1;
        if (dateText == "06:00 pm") showLabel = 1;
        if (dateText == "06:00 am") showLabel = 1;
        if (i == 23) isSliced = 1;
        plotData.push({
          label: dateTextDict[dateText],
          value: 100,
          color: colorMap[colorMapIndex],
          showLabel: showLabel,
          isSliced: isSliced,
          tooltext:
            dateTextDict[dateText] + ":" + hourlyTimeSeries[i].toString(),
        });
      }
      // console.log("hourly plotData", plotData);
      // console.log("totalDetections", totalDetections);

      var fusionDataset = {
        chart: {
          caption: "Past 24h",
          numberPrefix: "",
          bgColor: "#ffffff",
          startingAngle: startingAngle.toString(),
          showLegend: "0",
          enableSmartLabels: "1",
          showLabels: "0",
          showValues: "0",
          defaultCenterLabel: totalDetections.toString(),
          centerLabelFontSize: "18",
          centerLabelBold: "1",
          enableMultiSlicing: "0",
          animateClockwise: "1",
          showPercentInToolTip: "0",
        },
        data: plotData,
      };
      // console.log("fusionDataset", fusionDataset);
      return fusionDataset;
    },

    async getHeatmap(cn) {
      let nDays = 14;
      var nextToken = null;
      // this.lastUpdated = moment.utc().local().locale(this.selectedLanguage).calendar();
      let startDate, todayDate, refDate;
      var tempHits = [];

      refDate = moment.utc();
      todayDate = moment.utc().format();
      startDate = moment.utc().subtract(nDays, "days").format();
      // console.log(todayDate);
      if (this.recentHours == 0) {
        refDate = moment(this.hitDatePicker).utc();
        todayDate = moment(this.hitDatePicker).utc().format();
        startDate = moment(this.hitDatePicker)
          .utc()
          .subtract(nDays, "days")
          .format();
      }
      // console.log(startDate, todayDate, this.currentSerial)
      do {
        const queryHits = await API.graphql({
          query: hitsBySpeciesByDate,
          variables: {
            serial: this.currentSerial,
            cnDt: {
              between: [
                { cn: cn, dt: startDate },
                { cn: cn, dt: todayDate },
              ],
            },
            sortDirection: "DESC",
            nextToken: nextToken,
          },
        });
        tempHits = tempHits.concat(queryHits.data.hitsBySpeciesByDate.items);
        nextToken = queryHits.data.hitsBySpeciesByDate.nextToken;
      } while (nextToken != null);
      // console.log(tempHits);

      // data are in rows; each row is a single hour for all days
      // create empty array with zeros
      var heatmapData = [];

      for (var i = 0; i < 24; i++) {
        const zerosArray = Array(nDays).fill(0); // this needs to be in the loop to clone the array (otherwise all rows end up with same value)
        heatmapData.push(zerosArray);
      }
      // loop through all detections and add to correct hour and day bin
      tempHits.forEach((hit) => {
        // To Do: convert to local time to get correct hour and date bin
        var hourBin = moment.utc(hit["dt"]).tz(this.currentTimezone).hour();
        var hitDate = moment
          .utc(hit["dt"])
          .tz(this.currentTimezone)
          .diff(refDate.tz(this.currentTimezone).endOf("day"), "days");
        let dayBin = nDays + hitDate - 1;

        // increment heatmap
        // console.log('hit["dt"], day hourBin dayBin heatmap cell',hit["dt"], hitDate, hourBin, dayBin);
        heatmapData[hourBin][dayBin] += hit["detectionCount"];
      });

      const formattedDates = [];
      // Loop through the dates and format them as "MMM D" (e.g., "Oct 1", "Oct 2", ...)
      for (let i = nDays - 1; i >= 0; i--) {
        // Assuming you want 31 days for October
        let formattedDate = moment
          .utc()
          .tz(this.currentTimezone)
          .subtract(i, "days")
          .format("MMM D");

        if (this.recentHours == 0) {
          formattedDate = moment(this.hitDatePicker)
            .utc()
            .tz(this.currentTimezone)
            .subtract(i, "days")
            .format("MMM D");
        }
        formattedDates.push(formattedDate);
      }
      const formattedHours = [];
      for (let i = 0; i < 24; i++) {
        formattedHours.push(i + ":" + "00");
      }

      var heatmap = [
        {
          x: formattedDates,
          y: formattedHours,
          z: heatmapData,
          type: "heatmap",
          showscale: true,
          hoverongaps: false,
        },
      ];

      return heatmap;
    },

    // for charts.js plots
    async getDailySpeciesChartsJS(commonName) {
      // query daily table to get time series for year
      // console.log("getDailyCountsBySpecies commonName", commonName);

      var nextToken = null;
      var dailyCounts = [];
      do {
        const dailyCountSummary = await API.graphql({
          query: dailyCountSummaryBySerialBySpecies,
          variables: {
            serial: this.currentSerial,
            cn: { eq: commonName },
            nextToken: nextToken,
          },
        });
        dailyCounts = dailyCounts.concat(
          dailyCountSummary.data.dailyCountSummaryBySerialBySpecies.items
        );
        nextToken =
          dailyCountSummary.data.dailyCountSummaryBySerialBySpecies.nextToken;
      } while (nextToken != null);
      // console.log("daily counts", dailyCounts);

      // Create date array in case dates with no results
      let maxDate = moment.utc().format();
      let minDate = moment.utc().subtract(90, "days").format();
      function getDates(startDate, stopDate) {
        var dateArray = [];
        var currentDate = moment(startDate);
        stopDate = moment(stopDate);
        while (currentDate <= stopDate) {
          dateArray.push(moment(currentDate).format("YYYY-MM-DD"));
          currentDate = moment(currentDate).add(1, "days");
        }
        return dateArray;
      }
      let dateArr = getDates(minDate, maxDate);
      function getShortDates(startDate, stopDate) {
        var shortDateArray = [];
        var currentDate = moment(startDate);
        stopDate = moment(stopDate);
        while (currentDate <= stopDate) {
          shortDateArray.push(moment(currentDate).format("MM-DD"));
          currentDate = moment(currentDate).add(1, "days");
        }
        return shortDateArray;
      }
      let shortDateArr = getShortDates(minDate, maxDate);
      // console.log('dateArr', dateArr);
      // console.log('shortDateArr', shortDateArr);

      //
      // dailyCounts is sparse; add missing dates
      //

      // dateList will hold array of all dates to plot
      var dateList = [];
      for (let item in dailyCounts) {
        dateList.push(dailyCounts[item]["countDate"]);
      }
      // console.log('dateList', dateList);

      // create array with zeros
      let countArray = [];
      for (let i = 0; i < dateArr.length; i++) {
        countArray.push(0);
      }

      // loop through all dates with counts and subsitute actual count in countArray
      for (let i in dateList) {
        let countIndex = dateArr.indexOf(dateList[i]);
        countArray[countIndex] = dailyCounts[i].countsPerDay;
      }

      //console.log("countArray", countArray);

      var dailyCountPlotData = [];
      for (let item in dateArr) {
        dailyCountPlotData.push([shortDateArr[item], countArray[item]]);
      }
      // console.log("dailyCountPlotData", dailyCountPlotData);
      return dailyCountPlotData;
    },
    async setWindowAll(index, value, spCode, commonName) {

      // console.log("setWindowAll", index, value, commonName);
      if (this.seriesDaily[index].window == value)
        this.seriesDaily[index].window = "none";
      // toggle view
      else {
        if (value == "monthly") {
          this.seriesDaily[index].dataSource.data =
            await this.getDailyCountsBySpecies(commonName);
        }
        this.seriesDaily[index].window = value;
      }
      this.seriesDaily[index].id += 1; // increment ID so that component updates
      // console.log("setWindowAll", this.seriesDaily[index]);
    },
    setWindowNew(index, value) {
      this.newSpeciesList[index].window = value;
      this.newSpeciesList[index].id += 1; // increment ID so that component updates
      // console.log("Change Window", this.hits[index]);
    },
    setWindowMissing(index, value) {
      this.missingSpeciesList[index].window = value;
      this.missingSpeciesList[index].id += 1; // increment ID so that component updates
      // console.log("Change Window", this.hits[index]);
    },
    async labelHit(index, item) {
      // console.log("labelHit", index, item);
      if (!item.classLabel) return;

      // copy file to label bucket
      await Storage.copy(
        { key: item.wav, level: "public" },
        { key: "label/" + item.wav, level: "private" }
      );

      if (item.classLabel == "No it's a ...") {
        this.hits[index].showEntryBox = true;
        this.hits[index].showSubmitBox = true;
        this.hits[index].id += 1; // increment ID so that component updates
        // console.log("no its a");
        return;
      }

      const serial = item.serial;
      const dt = item.currentWav["dt"];
      const group = item.group;
      const cn = item.cn;
      const sn = item.sn;
      const spCode = item.spCode;
      const wav = item.currentWav["filename"];
      const labeledBy = this.user;
      const label = item.classLabel;
      const score = item.currentWav["score"];
      const lat = item.lat;
      const lon = item.lon;
      const labeledData = {
        serial,
        dt,
        group,
        cn,
        sn,
        spCode,
        wav,
        labeledBy,
        label,
        score,
        lat,
        lon,
      };
      API.graphql({
        query: createLabeledData,
        variables: { input: labeledData },
      });

      // console.log(labeledData);

      if (
        (item.classLabel == "No") |
        (item.classLabel == "Yes")
      ) {
        this.hits[index].showEntryBox = false;
        this.hits[index].id += 1; // increment ID so that component updates
      }
    },
    async testAudio() {
      this.playFile('bb/F412FADC999C/2025/06/26/F412FADC999C_1750896001.flac');
      // try {
      //     const url = await this.getAudioUrl('bb/F412FADC999C/2025/06/26/F412FADC999C_1750896001.flac');
      //     console.log('Audio URL:', url);
      //   } catch (error) {
      //     console.error('Error:', error);
      //   }
      },
    async getAudioUrl(audioPath) {
      try {
        const audioUrlResponse = await API.graphql({
          query: getAudioUrl,
          variables: {
            audioPath: audioPath
          }
        });
        
        return audioUrlResponse.data.getAudioUrl;
      } catch (error) {
        console.error('Error getting audio URL:', error);
        throw error;
      }      
    },

    labelHitCustom(index, item) {
      // console.log("labelHitCustom");
      if (!item.classLabel) return;
      const serial = item.serial;
      const dt = item.dt;
      const group = item.group;
      const cn = item.cn;
      const sn = item.sn;
      const spCode = item.spCode;
      const wav = item.wav;
      const labeledBy = this.user;
      const label = item.tellUsMore;
      const score = item.score;
      const lat = item.lat;
      const lon = item.lon;
      const labeledData = {
        serial,
        dt,
        group,
        cn,
        sn,
        spCode,
        wav,
        labeledBy,
        label,
        score,
        lat,
        lon,
      };
      API.graphql({
        query: createLabeledData,
        variables: { input: labeledData },
      });
      this.hits[index].submitted = true;
      this.hits[index].showSubmitBox = false;
      this.hits[index].id += 1; // increment ID so that component updates
    },
    // async addDeviceOwnersToNotice(){
    //   for (var i = 0; i<this.userIdList.length; i++){
    //     console.log(this.userIdList[i]);
    //     var id = this.noticeId + '-' + this.userIdList[i];
    //     var owner = this.userIdList[i];
    //     var noticeID = this.noticeId;
    //     var noticeViewed = "False";

    //     const noticeData = {
    //       id,
    //       owner,
    //       noticeID,
    //       noticeViewed
    //     };

    //     await API.graphql({
    //       query: createUserNotice,
    //       variables: {  input: noticeData },
    //     });
    //   }

    // },
  },
};
</script>

<style>
.admin-device-menu {
  max-height: 160px !important;
}
</style>
